var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense, useEffect, useState } from "react";
import { useStyles } from "./assets/style";
import "./assets/style.css"; // @ts-ignore
import { icons, sizesIcon, typeAlert, ButtonAFY, variants, sizes, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { themeCore } from "../../assets/themes/theme";
import * as catalogConst from "../../const/catalog";
import { STEP_CONFIRMATIONFORM } from "../../const/catalog";
import { formatPhoneNumber } from "../../utils/formats";
import { navigateNext, stepProgress } from "../../dataBase/stepProgress";
import { Customer } from "../../enum/customer";
import { Steps } from "../../enum/steps";
import { PostUploadDocuments } from "../../fnx/apaAuditDocuments/quoteUploadDocuments";
import { GetCatalogBeneficiary } from "../../fnx/catalog/getCatalogBeneficiary";
import { GetCatalogInsurance } from "../../fnx/catalog/getCatalogInsurance";
import { GetPaymentMode } from "../../fnx/paymentMode/getPaymentMode";
import { useCertificateQuote } from "../../fnx/certificate/certificateQuotes";
import { getCustomerAction, isCustomer } from "../../fnx/customer";
import { GetPersonByDocument } from "../../fnx/person/getPersonByDocument";
import { showToastSuccessMessage } from "../../fnx/sendSuccessMessage";
import { showErrorToast } from "../../fnx/showError";
import { formatDocument, getLogin, removeNonNumeric, transformToSelect, } from "../../services/functions";
import { hasPermission } from "../../services/getNavigationPages";
import LocalStorageService from "../../services/localStorage";
import showToast from "../../services/toast";
import { postQuoteUploadDocumentClearData } from "../../store/apapUploadAttachments/actions";
import { benefitClearData, getBeneficiary, patchBeneficiaryClearData, } from "../../store/beneficiary/actions";
import { certificateQuoteClearData } from "../../store/certificates/actions";
import { countries } from "../../store/countries/actions";
import { quoteClearData, quoteOne } from "../../store/generateQuote/actions";
import { identificationType } from "../../store/identificationType/actions";
import { insured, patchInsuredClearData, postInsuredClearData, } from "../../store/insured/actions";
import { pageActionFlagsClearData } from "../../store/pageActionFlags/actions";
import { personByDocumentClearData } from "../../store/person/actions";
import { catalogGender } from "../../store/plan/actions";
import { plans } from "../../store/plans/actions";
import { projectOne, projectOneClearData } from "../../store/project/actions";
import { region } from "../../store/region/actions";
import { formattedDate, newFormattedDate } from "../../utils/date";
import { formatNumberCustom, formatToTwoDecimals, parsePrice, } from "../../utils/getPrice";
import { AdditionalDocumentationColumns, dataEditVehicleForm, rowsClientDocument, StatementColumns, Tab1Columns, Tab2Columns, Tab3Columns, Tab4Columns, TabAutoColumns, } from "./resources/confirmationFormDto";
import { ConfirmationFormView } from "./ui/view"; /* Beneficiary */
import useBeneficiary from "./components/beneficiary"; /* Insurance */
import useInsurance from "./components/insurance"; /* Vehicle */
import useVehicle from "./components/vehicle"; /* ConfirmationForm */
import useClient from "./components/client"; /* Form Actions */
import useActions from "./components/ui"; /* Selectors */
import useSelectors from "./components/selectors"; /* Functions */
import useFunctions from "./components/functions";
import { PassengerDownloadModal } from "./resources/PassengerDownloadModal";
import PagesHeader from "ah_utility/PagesHeader";
import { useGetSteps } from "../../utils/getSteps";
import { findParamInLocalStorage } from "../../utils/getAnyDataLocalStorge";
import { ConfirmationHeader } from "./header";
import { useGetInformationSteps } from "../../utils/getInformationStep";
import { useGetSummary } from "../../utils/getSummary";
import { useStepNavigation } from "ah_utility/NavigationEngine";
var STEP = STEP_CONFIRMATIONFORM;
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
var storageKey3 = "afy-action-flags";
var lsPageActionFlags = new LocalStorageService(storageKey3);
var storageKey4 = "afy-steps";
var lsSteps = new LocalStorageService(storageKey4);
var ConfirmationForm = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var permissions = {
        create: hasPermission("sale-confirmation-form-create"),
    };
    var t = useTranslation().t;
    var classes = useStyles();
    var storageKey = "afy-steps";
    var localStorageService = new LocalStorageService(storageKey);
    var _r = React.useState(false), triggerPermissionList = _r[0], setTriggerPermissionList = _r[1];
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _s = React.useState(lsPageActionFlags.getPageActionFlagsStored()), actionFlags = _s[0], setActionFlags = _s[1];
    var _t = useState(""), planId = _t[0], setPlanId = _t[1];
    // const [filtersDTO, setFiltersDTO] = useState({});
    var _u = React.useState(false), openDrawerUpload = _u[0], setOpenDrawerUpload = _u[1];
    var _v = React.useState(""), idDocumentClient = _v[0], setIdDocumentClient = _v[1];
    var _w = useState(""), coverTypeId = _w[0], setCoverTypeId = _w[1];
    var _x = useState(""), campaignId = _x[0], setCampaignId = _x[1];
    var _y = useState(""), catalogPaymentMode = _y[0], setCatalogPaymentMode = _y[1];
    var _z = useState(""), catalogStatusQuote = _z[0], setCatalogStatusQuote = _z[1];
    var _0 = useState(""), branchId = _0[0], setBranchId = _0[1];
    var userId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _1 = React.useState(false), uploadTrigger = _1[0], setUploadTrigger = _1[1];
    var isVidaTermino = isCustomer(Customer.VIDA);
    var _2 = React.useState(""), period = _2[0], setPeriod = _2[1];
    var _3 = React.useState([]), breadCrumbs = _3[0], setBreadCrumbs = _3[1];
    var _4 = React.useState(false), showInsured = _4[0], setShowInsured = _4[1];
    var _5 = React.useState(false), showNewFormInsurance = _5[0], setShowNewFormInsurance = _5[1];
    var _6 = React.useState(false), showBeneficiary = _6[0], setShowBeneficiary = _6[1];
    var _7 = React.useState(true), addInsured = _7[0], setAddInsured = _7[1];
    var _8 = React.useState(false), addBeneficiary = _8[0], setAddBeneficiary = _8[1];
    var _9 = React.useState(false), showComponent = _9[0], setShowComponent = _9[1];
    var _10 = useState(false), openModalBackConfirm = _10[0], setOpenModalBackConfirm = _10[1];
    var _11 = React.useState(true), canEdit = _11[0], setCanEdit = _11[1];
    var _12 = React.useState(false), canEditLocation = _12[0], setCanEditLocation = _12[1];
    var _13 = React.useState(false), canEditContact = _13[0], setCanEditContact = _13[1];
    var _14 = React.useState([]), certificates = _14[0], setCertificates = _14[1];
    var _15 = useState([]), rows = _15[0], setRows = _15[1];
    var _16 = useState([]), rows2 = _16[0], setRows2 = _16[1];
    var _17 = useState([]), rowsBeneficiary = _17[0], setRowsBeneficiary = _17[1];
    var _18 = useState([]), rowsPassengers = _18[0], setRowsPassengers = _18[1];
    var _19 = React.useState(false), openActivePolicy = _19[0], setOpenActivePolicy = _19[1];
    var _20 = React.useState(false), showButtonActivatePolicy = _20[0], setShowButtonActivatePolicy = _20[1];
    var _21 = React.useState(""), policyId = _21[0], setPolicyId = _21[1];
    var _22 = React.useState(false), hideMarriedName = _22[0], setHideMarriedName = _22[1];
    var _23 = React.useState(""), namePlan = _23[0], setNamePlan = _23[1];
    var _24 = useState(false), isMaskedDocument = _24[0], setIsMaskedDocument = _24[1];
    var _25 = useState(""), personQuoteId = _25[0], setPersonQuoteId = _25[1];
    var _26 = useState(""), prime = _26[0], setPrime = _26[1];
    var _27 = useState(""), currency = _27[0], setCurrency = _27[1];
    var insuranceType = React.useState(localStorageService.getStepStored().steps[Steps.insurance].name
        ? localStorageService
            .getStepStored()
            .steps[Steps.insurance].name.toLowerCase()
        : "")[0];
    // const [steps, setSteps] = React.useState<MenuItem[]>([]);
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var _28 = React.useState(true), enable = _28[0], setEnable = _28[1];
    var _29 = React.useState([]), listIdentificationType = _29[0], setListIdentificationType = _29[1];
    var _30 = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _30[0], setSeeToast = _30[1];
    var id = useParams().id;
    var isQuote = useParams().isQuote;
    var isPlan = useParams().isPlan;
    var idProject = useParams().idProject;
    var isDocumentClient = useParams().isDocumentClient;
    var _31 = React.useState(false), projectTrigger = _31[0], setProjectTrigger = _31[1];
    var _32 = React.useState(false), triggerCatalog = _32[0], setTriggerCatalog = _32[1];
    var _33 = React.useState(false), triggerPaymentMode = _33[0], setTriggerPaymentMode = _33[1];
    var _34 = React.useState(false), triggerCertificate = _34[0], setTriggerCertificate = _34[1];
    var _35 = useState([]), listGenders = _35[0], setListGenders = _35[1];
    var _36 = useState(isQuote === "true"), isQuoteType = _36[0], setIsQuoteType = _36[1];
    var _37 = useState(false), canEditBeneficiary = _37[0], setCanEditBeneficiary = _37[1];
    var _38 = useState(false), canEditInsured = _38[0], setCanEditInsured = _38[1];
    var _39 = useState([]), listCountries = _39[0], setListCountries = _39[1];
    var _40 = useState([]), listRegionLevel1 = _40[0], setListRegionLevel1 = _40[1];
    var _41 = useState([]), listRegionLevel2 = _41[0], setListRegionLevel2 = _41[1];
    var _42 = useState([]), listRegionLevel3 = _42[0], setListRegionLevel3 = _42[1];
    var _43 = React.useState(1), page = _43[0], setPage = _43[1];
    var _44 = React.useState(""), idQuoteVehicle = _44[0], setIdQuoteVehicle = _44[1];
    var _45 = React.useState(""), productId = _45[0], setProductId = _45[1];
    var _46 = React.useState(10000), limit = _46[0], setLimit = _46[1];
    var _47 = React.useState(false), openModal = _47[0], setOpenModal = _47[1];
    var _48 = React.useState(false), openModalAddInsurance = _48[0], setOpenModalAddInsurance = _48[1];
    var _49 = React.useState(false), openModalPdfViewer = _49[0], setopenModalPdfViewer = _49[1];
    var _50 = React.useState(""), urlDocument = _50[0], setUrlDocument = _50[1];
    var _51 = React.useState(""), nameDocument = _51[0], setNameDocument = _51[1];
    var _52 = React.useState(""), personId = _52[0], setPersonId = _52[1];
    var _53 = React.useState(false), openModalBeneficiary = _53[0], setOpenModalBeneficiary = _53[1];
    var _54 = React.useState(transformToSelect(localStorageService.getStepStored().steps[Steps.plan].paymentMode)), paymentMode = _54[0], setPaymentMode = _54[1];
    var _55 = React.useState([
        { id: 1, name: "Sin datos", value: "-1" },
    ]), coverageType = _55[0], setCoverageType = _55[1];
    var _56 = React.useState([
        { id: 1, name: "Sin datos", value: "-1", code: "" },
    ]), insuredType = _56[0], setInsuredType = _56[1];
    var _57 = React.useState([
        { id: 1, name: "Sin datos", value: "-1" },
    ]), beneficiaryType = _57[0], setBeneficiaryType = _57[1];
    var _58 = React.useState(localStorageService.getStepStored().steps[Steps.insurance].campaign), campaign = _58[0], setCampaign = _58[1];
    var _59 = React.useState(""), planName = _59[0], setPlanName = _59[1];
    var _60 = React.useState(localStorageService.getStepStored().steps[Steps.insurance].campaign), campaigns = _60[0], setCampaigns = _60[1];
    var _61 = React.useState({
        id: (_b = (_a = localStorageService.getStepStored().steps[Steps.customer].campaignSelected) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : "",
        name: (_d = (_c = localStorageService.getStepStored().steps[Steps.customer].campaignSelected) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : "",
        value: (_f = (_e = localStorageService.getStepStored().steps[Steps.customer].campaignSelected) === null || _e === void 0 ? void 0 : _e.id) !== null && _f !== void 0 ? _f : "",
    }), campaignSelected = _61[0], setCampaignSelected = _61[1];
    var _62 = React.useState({
        id: localStorageService.getStepStored().steps[Steps.customer].id,
        name: localStorageService.getStepStored().steps[Steps.customer].name,
    }), plan = _62[0], setPlan = _62[1];
    var _63 = React.useState(), paymentSelected = _63[0], setPaymentSelected = _63[1];
    var _64 = React.useState(), planSelected = _64[0], setPlanSelected = _64[1];
    var _65 = React.useState(false), openModalEditVehicle = _65[0], setOpenModalEditVehicle = _65[1];
    var steps = useGetSteps();
    var _66 = React.useState({
        titlePage: "Plan",
        viewType: "2",
        titleMetaTag: "Affinity Plan",
        informationPage: {
            backgroundColor: themeCore.colors.background,
            colorText: themeCore.colors.secondaryText,
            description: "Seleccion el plan que necesite el cliente",
            icon: icons.Help,
            iconSize: sizesIcon.standard,
            iconColor: themeCore.colors.primary,
        },
        filter: {
            backgroundColor: "#FFFFFF",
            bgChipInsurers: "#fff",
            bgChipInsurersSelected: "#EBEEF6",
            bgColorButton: "#fff",
            bgColorComparativeButton: "#3A56A1",
            bgColorIconButton: "#EBEEF6",
            bgColorIconButtonSelected: "#3A56A1",
            colorIconButton: "#3A56A1",
            colorIconButtonSelected: "#fff",
            colorIconChip: "#3A56A1",
            colorText: "#3A56A1",
            comparativeTextButton: "ver comparativa",
            comparativeTextColor: "#fff",
            insurers: [],
            title: "Patrocinador",
            titleFirstChip: "Todas",
        },
        data: [],
    }), planData = _66[0], setPlanData = _66[1];
    var _67 = React.useState(localStorageService.getStepStored().steps[Steps.insurance].campaign), campaignInfo = _67[0], setCampaignInfo = _67[1];
    var level1 = "REGION_LEVEL1";
    var level2 = "REGION_LEVEL2";
    var level3 = "REGION_LEVEL3";
    var level4 = "REGION_LEVEL4";
    var _68 = React.useState(), coverType = _68[0], setCoverType = _68[1];
    var _69 = useState("Confirmación de Datos"), titleInsured = _69[0], setTitleInsured = _69[1];
    var _70 = useState("Ingresar beneficiario"), titleBeneficiary = _70[0], setTitleBeneficiary = _70[1];
    var _71 = React.useState(findParamInLocalStorage("projectId") || ""), projectId = _71[0], setProjectId = _71[1];
    var _72 = React.useState(false), isTravelInsurance = _72[0], setIsTravelInsurance = _72[1];
    // Get passenger counts from localStorage and calculate sum
    var edad020 = parseInt(findParamInLocalStorage("edad020") || "0");
    var edad2174 = parseInt(findParamInLocalStorage("edad2174") || "0");
    var edad7585 = parseInt(findParamInLocalStorage("edad7585") || "0");
    var _73 = React.useState(edad020 + edad2174 + edad7585), premiumSum = _73[0], setPremiumSum = _73[1];
    var _74 = useState(false), isUpdate = _74[0], setIsUpdate = _74[1];
    var _75 = React.useState(dataEditVehicleForm), dataFormVehicle = _75[0], setDataFormVehicle = _75[1];
    var _76 = useState({
        DocumentNumber: "",
        QuoteNumber: "",
        QuoteStatusName: "",
        QuoteDate: "",
        Type: "",
        PlanTypeName: "",
        CampaignName: "-",
        IdTypeName: "",
        Name: "",
        SecondName: "",
        FirstLastName: "",
        SecondLastName: "",
        MarriedSurName: "-",
        Gender: "",
        Birthday: "",
        Address1: "-",
        Address2: "-",
        CountryName: "",
        ProvinceName: "",
        TownName: "",
        SectorName: "",
        PostalCode: "",
        PhoneOffice: "",
        PhoneHome: "-",
        PhoneNumber: "-",
        Email: "",
    }), dataForm = _76[0], setDataForm = _76[1];
    var _77 = useState({
        Id: "",
        IdType: "",
        idTypeInsured: "",
        Percentage: "",
        DocumentNumber: "",
        Name: "",
        LastNameA: "",
        LastNameB: "",
        marriedName: "",
        Birthday: "",
        PhoneNumber: "",
        IdTypeName: "",
    }), dataFormBeneficiary = _77[0], setDataFormBeneficiary = _77[1];
    var _78 = useState({
        Id: "",
        IdType: "",
        idTypeInsured: "",
        DocumentNumber: "",
        Name: "",
        LastNameA: "",
        LastNameB: "",
        marriedName: "",
        Birthday: "",
        PhoneNumber: "",
        IdTypeName: "",
    }), dataFormInsurance = _78[0], setDataFormInsurance = _78[1];
    var _79 = useState({
        idInsuredType: "f97da54f-2ee9-4bca-8063-596b74057e34",
        Name: "",
        SecondName: "",
        FirstLastName: "",
        IdType: "",
        DocumentNumber: "",
        Birthday: "",
        Gender: "",
        MarriedSurName: "",
        Country: "99377891-b77a-42e2-9b84-803d1d5761d1",
        Province: "",
        Town: "",
        Sector: "",
        PostalCode: "",
        Address1: "",
        PhoneHome: "",
        PhoneNumber: "",
        PhoneOffice: "",
        Email: "",
    }), dataFormInsuranceSp = _79[0], setDataFormInsuranceSp = _79[1];
    var _80 = useState(45), initialPercentage = _80[0], setInitialPercentage = _80[1];
    var _81 = useState(false), trigger = _81[0], setTrigger = _81[1];
    var _82 = useState(), document = _82[0], setDocument = _82[1];
    var _83 = useState(false), isInsurance = _83[0], setIsInsurance = _83[1];
    var _84 = useState([]), listVehiclesDetail = _84[0], setListVehicles = _84[1];
    var _85 = React.useState({}), salesFlow = _85[0], setSalesFlow = _85[1];
    var _86 = React.useState([]), statementRows = _86[0], setStatementRows = _86[1];
    var _87 = React.useState([]), filters = _87[0], setFilters = _87[1];
    var _88 = React.useState([]), defaultFilters = _88[0], setDefaultFilters = _88[1];
    var _89 = React.useState(rowsClientDocument), profileDocumentsRows = _89[0], setProfileDocumentsRows = _89[1];
    var _90 = React.useState(0), countBadge = _90[0], setCountBadge = _90[1];
    var carDetails = React.useState((_g = lsSteps.getStepStored().steps[Steps.vehiclesDetails]) === null || _g === void 0 ? void 0 : _g.vehiclesDetails)[0];
    var company = React.useState(lsLogin.getUserLoginStored().subdomain || "")[0];
    var isApapAuto = getCustomerAction().customerAuto.includes(company);
    var hideTabDocumentClient = isApapAuto && (isQuote === "true" || isQuote === undefined);
    var isNotQuote = isQuote !== "false";
    var isApapAutoWithoutQuote = isApapAuto && !isNotQuote;
    var _91 = React.useState(""), fileName = _91[0], setFileName = _91[1];
    var _92 = React.useState(), pdfFile = _92[0], setPdfFile = _92[1];
    var _93 = React.useState(false), modalDocumentClient = _93[0], setModalDocumentClient = _93[1];
    var _94 = React.useState(""), urlDocumentClient = _94[0], setUrlDocumentClient = _94[1];
    var _95 = React.useState("false"), docName = _95[0], setDocName = _95[1];
    var _96 = React.useState(false), openModalPassenger = _96[0], setOpenModalPassenger = _96[1];
    var _97 = React.useState(""), urlDocumentPassenger = _97[0], setUrlDocumentPassenger = _97[1];
    var _98 = React.useState(""), nameDocumentPassenger = _98[0], setNameDocumentPassenger = _98[1];
    var _99 = React.useState(((_h = localStorageService.getStepStored().steps[Steps.customer]) === null || _h === void 0 ? void 0 : _h.paymentModeSelected) || { id: "", name: "", value: "" }), paymentModelSelected = _99[0], setPaymentModelSelected = _99[1];
    var _100 = React.useState(localStorageService.getStepStored().steps[Steps.customer].coverType), coverTypeSelected = _100[0], setCoverTypeSelected = _100[1];
    var _101 = useState(""), productType = _101[0], setProductType = _101[1];
    var projectTypeLocal = React.useRef((_k = (_j = lsSteps.getStepStored().steps[Steps.insurance].flow) === null || _j === void 0 ? void 0 : _j.metadata) === null || _k === void 0 ? void 0 : _k.navigation.productType);
    var _102 = useState(""), quoteId = _102[0], setQuoteId = _102[1];
    var isApap = getCustomerAction().customerAuto.includes(company);
    var Quote = React.useState(findParamInLocalStorage("Quote"))[0];
    var quoteIdLS = Quote === null || Quote === void 0 ? void 0 : Quote.id;
    var summary = useGetSummary();
    var pathname = useLocation().pathname;
    var pathLocation = "/" + pathname.split("/")[1];
    var _103 = React.useState({}), sessionData = _103[0], setSessionData = _103[1];
    var _104 = useStepNavigation({
        currentStepId: pathname,
        sessionData: sessionData,
        autoValidate: true,
    }), navigation = _104.navigation, isNextDisabled = _104.isNextDisabled, validationResult = _104.validationResult;
    var _105 = useGetInformationSteps(pathLocation), instanceId = _105.instanceId, workFlowId = _105.workFlowId, currentStep = _105.currentStep, nextStep = _105.nextStep;
    // Ref para controlar si ya se inicializó el país una vez
    var countryInitializedRef = React.useRef(false);
    useEffect(function () {
        // Solo setear el país una vez cuando listCountries se cargue por primera vez
        if (listCountries.length > 0 && !countryInitializedRef.current) {
            var countryId_1 = getLogin().countryId || "";
            if (countryId_1) {
                setDataFormInsuranceSp(function (prev) { return (__assign(__assign({}, prev), { Country: countryId_1 })); });
                countryInitializedRef.current = true;
            }
        }
    }, [listCountries]);
    var _106 = useSelectors(), loadingUpdateQuote = _106.loadingUpdateQuote, errorUpdateQuote = _106.errorUpdateQuote, responseIdentificationType = _106.responseIdentificationType, errorIdentificationType = _106.errorIdentificationType, responseCatalogGender = _106.responseCatalogGender, errorCatalogGender = _106.errorCatalogGender, responsePlan = _106.responsePlan, errorPlan = _106.errorPlan, loading = _106.loading, responseCountries = _106.responseCountries, errorCountries = _106.errorCountries, responseRegion = _106.responseRegion, errorRegion = _106.errorRegion, responsePlans = _106.responsePlans, errorPlans = _106.errorPlans, loadingPlans = _106.loadingPlans, responseInsured = _106.responseInsured, errorInsured = _106.errorInsured, responsePostInsured = _106.responsePostInsured, errorPostInsured = _106.errorPostInsured, loadingPostInsured = _106.loadingPostInsured, responsePatchInsured = _106.responsePatchInsured, errorPatchInsured = _106.errorPatchInsured, loadingPatchInsured = _106.loadingPatchInsured, responseUpdatePerson = _106.responseUpdatePerson, errorUpdatePerson = _106.errorUpdatePerson, loadingUpdatePerson = _106.loadingUpdatePerson, responseBenefit = _106.responseBenefit, errorBenefit = _106.errorBenefit, loadingBenefit = _106.loadingBenefit, responsePatchBeneficiary = _106.responsePatchBeneficiary, errorPatchBeneficiary = _106.errorPatchBeneficiary, loadingPatchBeneficiary = _106.loadingPatchBeneficiary, responseBeneficiary = _106.responseBeneficiary, errorBeneficiary = _106.errorBeneficiary, loadingBeneficiary = _106.loadingBeneficiary, responsePageActionFlags = _106.responsePageActionFlags, responseOneProject = _106.responseOneProject, loadingOneProject = _106.loadingOneProject, errorOneQuote = _106.errorOneQuote, responseOneQuote = _106.responseOneQuote, loadingOneQuote = _106.loadingOneQuote, loadingInsured = _106.loadingInsured;
    var updateVehicle = useVehicle(setOpenModalEditVehicle).updateVehicle;
    var _107 = useClient(paymentMode, setPeriod, setPaymentModelSelected, setPaymentMode, paymentModelSelected, coverTypeSelected, plans, enable, page, limit, projectId, namePlan, clientId, setCoverTypeSelected, campaigns, setCampaignSelected, level2, level3, setListRegionLevel3, listGenders, setHideMarriedName, setCoverType, setPaymentSelected, setPlanSelected, setPlan, campaignSelected, personQuoteId, hideMarriedName, salesFlow, setCampaign, setCampaigns, setFileName, setPdfFile, setUploadTrigger, actionFlags, isQuote, setShowInsured, setAddInsured, setShowBeneficiary, setAddBeneficiary, setCanEditInsured, setCanEditBeneficiary, responseOneQuote, setTriggerCertificate, setUrlDocument, setopenModalPdfViewer, catalogPaymentMode, setDataForm, setDefaultFilters, setPrime, dataForm, setShowNewFormInsurance), searchPerson = _107.searchPerson, handleSearch = _107.handleSearch, callDispatchPlan = _107.callDispatchPlan, callDispatchPlanAfterQuoteLoaded = _107.callDispatchPlanAfterQuoteLoaded, handleOnChangePaymentMethod = _107.handleOnChangePaymentMethod, handleOnChangeCoverType = _107.handleOnChangeCoverType, handleOnChangeCampaign = _107.handleOnChangeCampaign, handleChangeSelect = _107.handleChangeSelect, handleChangeSelectFormInsurance = _107.handleChangeSelectFormInsurance, handleUpdatePerson = _107.handleUpdatePerson, handleDownload = _107.handleDownload, updateDataFormPerson = _107.updateDataFormPerson, setCoverTypeStorybook = _107.setCoverTypeStorybook, handleOnClickAcquire = _107.handleOnClickAcquire, quoteUploadDocuments = _107.quoteUploadDocuments, callQuoteOne = _107.callQuoteOne, getActionFlags = _107.getActionFlags, handleOnClickAutoDownload = _107.handleOnClickAutoDownload, handleOnClickAutoDownloadVida = _107.handleOnClickAutoDownloadVida, setLocalStorage = _107.setLocalStorage, callDispatchPageActionFlags = _107.callDispatchPageActionFlags, showVehicleData = _107.showVehicleData, showDownloadQuote = _107.showDownloadQuote, showDownloadRequest = _107.showDownloadRequest;
    var _108 = useInsurance(setTitleInsured, setIsUpdate, setOpenModal, setOpenModalAddInsurance, dataFormInsurance, setDataFormInsurance, dataFormInsuranceSp, setDataFormInsuranceSp, setRows, responseOneQuote, quoteId ? quoteId : id, clientId, personId, isUpdate, setIsMaskedDocument, setPersonId, listIdentificationType, insuredType, setIsInsurance, setDocument, setTrigger, showNewFormInsurance, setSeeToast), handleAddInsured = _108.handleAddInsured, setInsuranceStorybook = _108.setInsuranceStorybook, handleSubmitInsured = _108.handleSubmitInsured, editInsured = _108.editInsured, searchInsurancePerson = _108.searchInsurancePerson;
    var _109 = useBeneficiary(setIsUpdate, setInitialPercentage, setTitleBeneficiary, setOpenModalBeneficiary, dataFormBeneficiary, setDataFormBeneficiary, initialPercentage, responseOneQuote, clientId, isUpdate, setIsMaskedDocument, setPersonId, listIdentificationType), setBeneficiaryStorybook = _109.setBeneficiaryStorybook, handleAddBeneficiary = _109.handleAddBeneficiary, handleSubmitBeneficiary = _109.handleSubmitBeneficiary, getInsuredBeneficiary = _109.getInsuredBeneficiary, editBeneficiary = _109.editBeneficiary;
    var _110 = useActions(setOpenDrawerUpload, setPdfFile, setFileName, setIdDocumentClient, setModalDocumentClient, setUrlDocumentClient, setDocName, isVidaTermino, navigate, navigateNext, STEP, id, setOpenModalBackConfirm, isPlan, isDocumentClient, workFlowId, instanceId, currentStep, nextStep, pathLocation, navigation), handleNext = _110.handleNext, handlePrevious = _110.handlePrevious, onClickBack = _110.onClickBack, handleCloseBackModal = _110.handleCloseBackModal, handleBackFromModal = _110.handleBackFromModal, handleClickContextMenu = _110.handleClickContextMenu, loadingComplete = _110.loadingComplete;
    var filterData = useFunctions().filterData;
    var _111 = useCertificateQuote(triggerCertificate, "cotizacion", quoteId, 1, 20), responseCertificateQuote = _111.responseCertificateQuote, errorCertificateQuote = _111.errorCertificateQuote, loadingCertificateQuote = _111.loadingCertificateQuote;
    var _112 = PostUploadDocuments(uploadTrigger, id ? id : quoteId, fileName, pdfFile, idDocumentClient), responseUploadDocuments = _112.responseUploadDocuments, errorUploadDocuments = _112.errorUploadDocuments, loadingUploadDocuments = _112.loadingUploadDocuments;
    var _113 = GetCatalogBeneficiary(triggerCatalog, enable, page, limit, clientId), responseGetCatalogBeneficiary = _113.responseGetCatalogBeneficiary, errorGetCatalogBeneficiary = _113.errorGetCatalogBeneficiary, loadingGetCatalogBeneficiary = _113.loadingGetCatalogBeneficiary;
    var _114 = GetCatalogInsurance(triggerCatalog, enable, page, limit, clientId), responseGetCatalogInsurance = _114.responseGetCatalogInsurance, errorGetCatalogInsurance = _114.errorGetCatalogInsurance, loadingGetCatalogInsurance = _114.loadingGetCatalogInsurance;
    var _115 = GetPersonByDocument(trigger, document), responsePersonByDocument = _115.responsePersonByDocument, errorPersonByDocument = _115.errorPersonByDocument, loadingPersonByDocument = _115.loadingPersonByDocument;
    var _116 = GetPaymentMode(triggerPaymentMode, projectId || idProject || ""), responsePaymentMode = _116.responsePaymentMode, errorPaymentMode = _116.errorPaymentMode, loadingPaymentMode = _116.loadingPaymentMode;
    useEffect(function () {
        var _a;
        // Clear PageActionFlags redux state on first load
        dispatch(pageActionFlagsClearData());
        // Remove summary from localStorage if coming from insurancePoliciesSummary
        if (idProject) {
            console.log("Removing summary from localStorage - coming from insurancePoliciesSummary");
            localStorage.removeItem("summary");
        }
        setProjectTrigger(true);
        if (idProject || projectId) {
            dispatch(projectOne({
                id: idProject ? idProject : projectId,
            }));
        }
        setTriggerCatalog(true);
        setTriggerPaymentMode(true);
        getActionFlags();
        if (!responseIdentificationType) {
            dispatch(identificationType({ enable: enable, page: page, limit: limit }));
        }
        if (!responseCountries) {
            dispatch(countries({ enable: enable, page: page, limit: limit }));
        }
        if (!(responseCatalogGender === null || responseCatalogGender === void 0 ? void 0 : responseCatalogGender.data)) {
            dispatch(catalogGender({ enable: enable, page: page, limit: limit }));
        }
        //Get Quote //
        var quoteIdLs = quoteIdLS;
        if (id !== undefined) {
            dispatch(quoteClearData());
            setCanEdit(isQuoteType);
            if (!isQuoteType) {
                setCanEditLocation(true);
                setCanEditContact(true);
            }
            //Get the quote by id
            callQuoteOne(id);
        }
        else {
            callQuoteOne(quoteIdLs);
        }
        callGetInsuredBeneficiary((_a = id !== null && id !== void 0 ? id : quoteIdLs) !== null && _a !== void 0 ? _a : "");
        // Note: callDispatchPlan moved to useEffect that waits for responseOneQuote
        //if (permissionList?.length === 0) {
        //setTriggerPermissionList(true);
        //}
        //if (permissionList?.length === 0) {
        //setTriggerPermissionList(true);
        console.log("isQuoteType---", isQuoteType);
        //}
    }, []);
    /* Handle Errors */
    useEffect(function () {
        if (errorPersonByDocument) {
            showErrorToast(errorPersonByDocument, setSeeToast, t);
        }
    }, [errorPersonByDocument]);
    useEffect(function () {
        if (errorOneQuote) {
            showErrorToast(errorOneQuote, setSeeToast, t);
        }
    }, [errorOneQuote]);
    useEffect(function () {
        if (errorInsured) {
            showErrorToast(errorInsured, setSeeToast, t);
        }
    }, [errorInsured]);
    useEffect(function () {
        if (errorCatalogGender) {
            showErrorToast(errorCatalogGender, setSeeToast, t);
        }
    }, [errorCatalogGender]);
    useEffect(function () {
        if (errorCountries) {
            showErrorToast(errorCountries, setSeeToast, t);
        }
    }, [errorCountries]);
    useEffect(function () {
        if (errorRegion) {
            showErrorToast(errorRegion, setSeeToast, t);
        }
    }, [errorRegion]);
    useEffect(function () {
        if (errorUpdateQuote) {
            showErrorToast(errorUpdateQuote, setSeeToast, t);
        }
    }, [errorUpdateQuote]);
    useEffect(function () {
        if (errorPlan) {
            showErrorToast(errorPlan, setSeeToast, t);
        }
    }, [errorPlan]);
    useEffect(function () {
        if (errorBeneficiary) {
            showErrorToast(errorBeneficiary, setSeeToast, t);
        }
    }, [errorBeneficiary]);
    useEffect(function () {
        if (errorIdentificationType) {
            showErrorToast(errorIdentificationType, setSeeToast, t);
        }
    }, [errorIdentificationType]);
    useEffect(function () {
        if (errorUpdatePerson) {
            showErrorToast(errorUpdatePerson, setSeeToast, t);
        }
    }, [errorUpdatePerson]);
    useEffect(function () {
        if (errorPatchBeneficiary) {
            showErrorToast(errorPatchBeneficiary, setSeeToast, t);
            dispatch(patchBeneficiaryClearData());
        }
    }, [errorPatchBeneficiary]);
    useEffect(function () {
        if (errorPatchInsured) {
            showErrorToast(errorPatchInsured, setSeeToast, t);
            dispatch(patchInsuredClearData());
        }
    }, [errorPatchInsured]);
    useEffect(function () {
        if (errorBenefit) {
            showErrorToast(errorBenefit, setSeeToast, t);
            dispatch(benefitClearData());
        }
    }, [errorBenefit]);
    useEffect(function () {
        if (errorPostInsured) {
            showErrorToast(errorPostInsured, setSeeToast, t);
            dispatch(postInsuredClearData());
        }
    }, [errorPostInsured]);
    useEffect(function () {
        if (errorPlans) {
            showErrorToast(errorPlans, setSeeToast, t);
        }
    }, [errorPlans]);
    useEffect(function () {
        if (errorUploadDocuments) {
            showErrorToast(errorUploadDocuments, setSeeToast, t);
        }
    }, [errorUploadDocuments]);
    useEffect(function () {
        if (errorPaymentMode) {
            showErrorToast(errorPaymentMode, setSeeToast, t);
        }
    }, [errorPaymentMode]);
    useEffect(function () {
        var _a, _b, _c;
        if (responsePaymentMode && responsePaymentMode.length > 0) {
            // Transform payment mode response to select format
            var paymentModeList_1 = [];
            var quotePaymentModeId_1 = (_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.id;
            responsePaymentMode.map(function (item) {
                var _a, _b, _c, _d;
                var itemId = ((_a = item.catalogPaymentMode) === null || _a === void 0 ? void 0 : _a.id) || item.id;
                paymentModeList_1.push({
                    id: itemId,
                    name: ((_b = item.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.description) || item.description || "",
                    value: ((_c = item.catalogPaymentMode) === null || _c === void 0 ? void 0 : _c.code) ||
                        ((_d = item.catalogPaymentMode) === null || _d === void 0 ? void 0 : _d.id) ||
                        item.id,
                    default: quotePaymentModeId_1 ? itemId === quotePaymentModeId_1 : false,
                });
            });
            setPaymentMode(paymentModeList_1);
            // Set initial payment mode selection only if not already set and no quote data available
            if (!(paymentModelSelected === null || paymentModelSelected === void 0 ? void 0 : paymentModelSelected.id) &&
                paymentModeList_1.length > 0 &&
                !((_c = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _c === void 0 ? void 0 : _c.catalogPaymentMode)) {
                setPaymentModelSelected(paymentModeList_1[0]);
                // Set initial period when payment mode is first loaded
                setPeriod(paymentModeList_1[0].name);
            }
        }
    }, [responsePaymentMode, (_m = (_l = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _l === void 0 ? void 0 : _l.catalogPaymentMode) === null || _m === void 0 ? void 0 : _m.id]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if (responseOneQuote && (responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data)) {
            var combustionMap = {
                GASOLINE: "Gasolina",
                DIESEL: "Diesel",
                ELECTRIC: "Eléctrico",
                GAS: "Gas",
            };
            var combustionType = (_a = responseOneQuote.data.contentMap) === null || _a === void 0 ? void 0 : _a.combustion;
            var carCombustion = combustionMap[combustionType] || "";
            var price = parsePrice(((_b = responseOneQuote.data.contentMap) === null || _b === void 0 ? void 0 : _b.deductibleTypeId) || 0);
            var newPrice = formatNumberCustom(price || 0);
            var car = {
                id: 1,
                brand: (_d = (_c = responseOneQuote.data.contentMap) === null || _c === void 0 ? void 0 : _c.brand) === null || _d === void 0 ? void 0 : _d.name,
                model: (_f = (_e = responseOneQuote.data.contentMap) === null || _e === void 0 ? void 0 : _e.model) === null || _f === void 0 ? void 0 : _f.name,
                fueltype: carCombustion,
                color: (_h = (_g = responseOneQuote.data.contentMap) === null || _g === void 0 ? void 0 : _g.colors) === null || _h === void 0 ? void 0 : _h.name,
                price: "RD$ ".concat(newPrice),
                cylinders: (_j = responseOneQuote.data.contentMap) === null || _j === void 0 ? void 0 : _j.cylinders,
                plate: (_k = responseOneQuote.data.contentMap) === null || _k === void 0 ? void 0 : _k.plate,
            };
            var vehicleDet = [];
            vehicleDet.push(car);
            setListVehicles(vehicleDet);
        }
    }, [responseOneQuote]);
    useEffect(function () {
        var _a, _b, _c, _d;
        if (responseCertificateQuote && ((_a = responseCertificateQuote.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var urlC = (_b = responseCertificateQuote.data[0]) === null || _b === void 0 ? void 0 : _b.url;
            if (urlC) {
                setUrlDocument(urlC);
                setNameDocument((_c = responseCertificateQuote.data[0]) === null || _c === void 0 ? void 0 : _c.title);
                setopenModalPdfViewer(true);
            }
            setTriggerCertificate(false);
            dispatch(certificateQuoteClearData());
        }
        else if (responseCertificateQuote &&
            ((_d = responseCertificateQuote.data) === null || _d === void 0 ? void 0 : _d.length) === 0) {
            setTriggerCertificate(false);
            showToastSuccessMessage("No se encontro ningun documento adjunto.", typeAlert.warning, setSeeToast);
            dispatch(certificateQuoteClearData());
        }
    }, [responseCertificateQuote]);
    useEffect(function () {
        if (errorCertificateQuote) {
            showErrorToast(errorCertificateQuote, setSeeToast, t);
        }
    }, [errorCertificateQuote]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106, _107, _108, _109, _110, _111, _112, _113, _114, _115, _116, _117, _118, _119, _120, _121, _122, _123, _124, _125, _126, _127, _128, _129, _130, _131, _132, _133, _134, _135, _136, _137, _138, _139, _140, _141, _142, _143, _144, _145, _146, _147, _148, _149, _150, _151, _152, _153, _154, _155, _156, _157, _158, _159, _160, _161, _162, _163, _164, _165;
        if (responseOneQuote && (responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data)) {
            setPersonQuoteId((_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.personId);
            setQuoteId((_b = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _b === void 0 ? void 0 : _b.id);
            setPlanId((_d = (_c = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _c === void 0 ? void 0 : _c.planId) === null || _d === void 0 ? void 0 : _d.id);
            setCoverTypeId((_f = (_e = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _e === void 0 ? void 0 : _e.coverType) === null || _f === void 0 ? void 0 : _f.id);
            setCampaignId((_h = (_g = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _g === void 0 ? void 0 : _g.campaignId) === null || _h === void 0 ? void 0 : _h.id);
            setCatalogPaymentMode((_k = (_j = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _j === void 0 ? void 0 : _j.catalogPaymentMode) === null || _k === void 0 ? void 0 : _k.id);
            setShowButtonActivatePolicy(((_o = (_m = (_l = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _l === void 0 ? void 0 : _l.policyId) === null || _m === void 0 ? void 0 : _m.policyStatus) === null || _o === void 0 ? void 0 : _o.description) ===
                "Pendiente" ||
                ((_r = (_q = (_p = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _p === void 0 ? void 0 : _p.policyId) === null || _q === void 0 ? void 0 : _q.policyStatus) === null || _r === void 0 ? void 0 : _r.description) ===
                    "pendiente");
            setPolicyId((_t = (_s = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _s === void 0 ? void 0 : _s.policyId) === null || _t === void 0 ? void 0 : _t.id);
            // Update paymentModelSelected with the catalogPaymentMode from quote
            if ((_u = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _u === void 0 ? void 0 : _u.catalogPaymentMode) {
                var selectedPaymentMode = {
                    id: responseOneQuote.data.catalogPaymentMode.id,
                    name: responseOneQuote.data.catalogPaymentMode.description,
                    value: responseOneQuote.data.catalogPaymentMode.code ||
                        responseOneQuote.data.catalogPaymentMode.id,
                    label: responseOneQuote.data.catalogPaymentMode.description,
                };
                setPaymentModelSelected(selectedPaymentMode);
                // Set period from quote data
                setPeriod(responseOneQuote.data.catalogPaymentMode.description);
                // Update paymentMode array to mark the correct option as default
                if (paymentMode.length > 0) {
                    var updatedPaymentMode = paymentMode.map(function (mode) { return (__assign(__assign({}, mode), { default: mode.id === responseOneQuote.data.catalogPaymentMode.id })); });
                    setPaymentMode(updatedPaymentMode);
                }
            }
            setCatalogStatusQuote((_w = (_v = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _v === void 0 ? void 0 : _v.catalogStatusQuote) === null || _w === void 0 ? void 0 : _w.id);
            setBranchId((_x = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _x === void 0 ? void 0 : _x.branch);
            setPlanName((_z = (_y = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _y === void 0 ? void 0 : _y.planId) === null || _z === void 0 ? void 0 : _z.name);
            // getInsuredBeneficiary();
            var gender = listGenders.find(function (g) { var _a, _b; return g.id === ((_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.catalogGender) === null || _b === void 0 ? void 0 : _b.id); });
            var HideMarriedName = (gender === null || gender === void 0 ? void 0 : gender.name) === "Femenino" ? false : true;
            setHideMarriedName(HideMarriedName);
            /*date = formattedDate(date);*/
            //Province
            dispatch(region({
                enable: enable,
                page: page,
                limit: limit,
                level: level1,
                clientId: lsLogin.getUserLoginStored().clientId,
            }));
            //Municipality
            dispatch(region({
                enable: enable,
                page: page,
                limit: limit,
                level: level2,
                parentRegionId: (_1 = (_0 = responseOneQuote.data) === null || _0 === void 0 ? void 0 : _0.municipality) === null || _1 === void 0 ? void 0 : _1.parentRegionId,
                clientId: lsLogin.getUserLoginStored().clientId,
            }));
            //District
            dispatch(region({
                enable: enable,
                page: page,
                limit: limit,
                level: level3,
                parentRegionId: (_3 = (_2 = responseOneQuote.data) === null || _2 === void 0 ? void 0 : _2.district) === null || _3 === void 0 ? void 0 : _3.parentRegionId,
                clientId: lsLogin.getUserLoginStored().clientId,
            }));
            var status = (_5 = (_4 = responseOneQuote.data) === null || _4 === void 0 ? void 0 : _4.catalogStatusQuote) === null || _5 === void 0 ? void 0 : _5.description;
            if (status == "Cancelada") {
                status = "Fecha de cancelación";
            }
            else if (status == "Emitida") {
                status = "Fecha de emisión";
            }
            else if (status == "Expirada") {
                status = "Fecha de expiración";
            }
            else {
                status = "Fecha de cotización";
            }
            var date = ((_7 = (_6 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _6 === void 0 ? void 0 : _6.policyId) === null || _7 === void 0 ? void 0 : _7.effectiveFrom) ||
                ((_8 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _8 === void 0 ? void 0 : _8.creationDate);
            var nextYearDate = undefined;
            var originalDate = void 0;
            if (date) {
                var originalDate_1 = new Date(date);
                originalDate_1.setFullYear(originalDate_1.getFullYear() + 1);
                nextYearDate = formattedDate(originalDate_1.toISOString());
                nextYearDate = originalDate_1.toISOString();
            }
            setDataForm({
                DocumentNumber: formatDocument(responseOneQuote && ((_9 = responseOneQuote.data) === null || _9 === void 0 ? void 0 : _9.numberId)),
                IdType: ((_11 = (_10 = responseOneQuote.data) === null || _10 === void 0 ? void 0 : _10.identificationTypeId) === null || _11 === void 0 ? void 0 : _11.id)
                    ? (_13 = (_12 = responseOneQuote.data) === null || _12 === void 0 ? void 0 : _12.identificationTypeId) === null || _13 === void 0 ? void 0 : _13.id
                    : "",
                Type: responseOneQuote &&
                    ((_15 = (_14 = responseOneQuote.data) === null || _14 === void 0 ? void 0 : _14.identificationTypeId) === null || _15 === void 0 ? void 0 : _15.description),
                QuoteNumber: ((_16 = responseOneQuote.data) === null || _16 === void 0 ? void 0 : _16.policyId)
                    ? (_17 = responseOneQuote.data) === null || _17 === void 0 ? void 0 : _17.policyId.code
                    : responseOneQuote && ((_18 = responseOneQuote.data) === null || _18 === void 0 ? void 0 : _18.code),
                Name: responseOneQuote && ((_19 = responseOneQuote.data) === null || _19 === void 0 ? void 0 : _19.firstNameA),
                SecondName: responseOneQuote && ((_20 = responseOneQuote.data) === null || _20 === void 0 ? void 0 : _20.firstNameB),
                FirstLastName: responseOneQuote && ((_21 = responseOneQuote.data) === null || _21 === void 0 ? void 0 : _21.lastNameA),
                SecondLastName: responseOneQuote && ((_22 = responseOneQuote.data) === null || _22 === void 0 ? void 0 : _22.lastNameB),
                MarriedSurName: responseOneQuote && ((_23 = responseOneQuote.data) === null || _23 === void 0 ? void 0 : _23.marriedName),
                Birthday: responseOneQuote && ((_24 = responseOneQuote.data) === null || _24 === void 0 ? void 0 : _24.dob),
                Address1: responseOneQuote && ((_25 = responseOneQuote.data) === null || _25 === void 0 ? void 0 : _25.address1),
                Address2: responseOneQuote && ((_26 = responseOneQuote.data) === null || _26 === void 0 ? void 0 : _26.address2),
                PhoneOffice: responseOneQuote && formatPhoneNumber((_27 = responseOneQuote.data) === null || _27 === void 0 ? void 0 : _27.phone2),
                PhoneHome: responseOneQuote && formatPhoneNumber((_28 = responseOneQuote.data) === null || _28 === void 0 ? void 0 : _28.phone1),
                PhoneNumber: responseOneQuote && formatPhoneNumber((_29 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _29 === void 0 ? void 0 : _29.phone3),
                Email: responseOneQuote && ((_30 = responseOneQuote.data) === null || _30 === void 0 ? void 0 : _30.email),
                QuoteStatusName: responseOneQuote &&
                    ((_32 = (_31 = responseOneQuote.data) === null || _31 === void 0 ? void 0 : _31.catalogStatusQuote) === null || _32 === void 0 ? void 0 : _32.description),
                QuoteDate: date,
                effectiveDate: responseOneQuote && ((_33 = responseOneQuote.data) === null || _33 === void 0 ? void 0 : _33.policyId)
                    ? nextYearDate
                    : "",
                PlanTypeName: responseOneQuote && ((_35 = (_34 = responseOneQuote.data) === null || _34 === void 0 ? void 0 : _34.planId) === null || _35 === void 0 ? void 0 : _35.name),
                CampaignName: responseOneQuote && ((_37 = (_36 = responseOneQuote.data) === null || _36 === void 0 ? void 0 : _36.campaignId) === null || _37 === void 0 ? void 0 : _37.name),
                IdTypeName: responseOneQuote &&
                    ((_39 = (_38 = responseOneQuote.data) === null || _38 === void 0 ? void 0 : _38.identificationTypeId) === null || _39 === void 0 ? void 0 : _39.description),
                Gender: responseOneQuote && ((_41 = (_40 = responseOneQuote.data) === null || _40 === void 0 ? void 0 : _40.catalogGender) === null || _41 === void 0 ? void 0 : _41.id),
                Country: responseOneQuote && ((_43 = (_42 = responseOneQuote.data) === null || _42 === void 0 ? void 0 : _42.nationality) === null || _43 === void 0 ? void 0 : _43.id),
                CountryName: responseOneQuote && ((_45 = (_44 = responseOneQuote.data) === null || _44 === void 0 ? void 0 : _44.nationality) === null || _45 === void 0 ? void 0 : _45.name),
                Province: responseOneQuote && ((_47 = (_46 = responseOneQuote.data) === null || _46 === void 0 ? void 0 : _46.province) === null || _47 === void 0 ? void 0 : _47.id),
                ProvinceName: responseOneQuote && ((_49 = (_48 = responseOneQuote.data) === null || _48 === void 0 ? void 0 : _48.province) === null || _49 === void 0 ? void 0 : _49.name),
                TownName: responseOneQuote && ((_51 = (_50 = responseOneQuote.data) === null || _50 === void 0 ? void 0 : _50.municipality) === null || _51 === void 0 ? void 0 : _51.name),
                Town: responseOneQuote && ((_53 = (_52 = responseOneQuote.data) === null || _52 === void 0 ? void 0 : _52.municipality) === null || _53 === void 0 ? void 0 : _53.id),
                Sector: responseOneQuote && ((_55 = (_54 = responseOneQuote.data) === null || _54 === void 0 ? void 0 : _54.district) === null || _55 === void 0 ? void 0 : _55.id),
                SectorName: responseOneQuote && ((_57 = (_56 = responseOneQuote.data) === null || _56 === void 0 ? void 0 : _56.district) === null || _57 === void 0 ? void 0 : _57.name),
                PostalCode: responseOneQuote && ((_58 = responseOneQuote.data) === null || _58 === void 0 ? void 0 : _58.zip),
            });
            //setFormVehicle
            setIdQuoteVehicle((_60 = (_59 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _59 === void 0 ? void 0 : _59.contentMap) === null || _60 === void 0 ? void 0 : _60.idquoteVehicle);
            setProductId((_62 = (_61 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _61 === void 0 ? void 0 : _61.productId) === null || _62 === void 0 ? void 0 : _62.id);
            var carConditionName = void 0;
            switch ((_64 = (_63 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _63 === void 0 ? void 0 : _63.contentMap) === null || _64 === void 0 ? void 0 : _64.condition) {
                case "USED":
                    carConditionName = "Usado";
                    break;
                case "NEW":
                    carConditionName = "Nuevo";
                    break;
            }
            if ((_65 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _65 === void 0 ? void 0 : _65.profileDocuments) {
                var pendingCount = responseOneQuote.data.profileDocuments.filter(function (doc) { return (doc === null || doc === void 0 ? void 0 : doc.status) === "PENDING"; }).length;
                setCountBadge(pendingCount);
                var dataRows = (_67 = (_66 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _66 === void 0 ? void 0 : _66.profileDocuments) === null || _67 === void 0 ? void 0 : _67.map(function (item) {
                    var _a;
                    return ({
                        id: item.id,
                        docType: item.name,
                        state: (function () {
                            switch (item.status) {
                                case "PENDING":
                                    return "Pendiente";
                                case "READY":
                                    return "Listo";
                            }
                        })(),
                        date: "",
                        user: "",
                        documentClientUrl: ((_a = item.document) === null || _a === void 0 ? void 0 : _a.path) || "",
                    });
                });
                setProfileDocumentsRows(dataRows);
            }
            var fuelTypeName = void 0;
            switch ((_69 = (_68 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _68 === void 0 ? void 0 : _68.contentMap) === null || _69 === void 0 ? void 0 : _69.combustion) {
                case "GAS":
                    fuelTypeName = "Gas";
                    break;
                case "ELECTRIC":
                    fuelTypeName = "Eléctrico";
                    break;
                case "DIESEL":
                    fuelTypeName = "Diesel";
                    break;
                case "GASOLINE":
                    fuelTypeName = "Gasolina";
                    break;
            }
            var countChassis = ((_71 = (_70 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _70 === void 0 ? void 0 : _70.contentMap) === null || _71 === void 0 ? void 0 : _71.chassisNumber) || "";
            var isChassisValid = (countChassis === null || countChassis === void 0 ? void 0 : countChassis.length) !== 17;
            setDataFormVehicle({
                carDetails: [
                    {
                        brand: {
                            id: (_74 = (_73 = (_72 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _72 === void 0 ? void 0 : _72.contentMap) === null || _73 === void 0 ? void 0 : _73.brand) === null || _74 === void 0 ? void 0 : _74.id,
                            name: (_77 = (_76 = (_75 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _75 === void 0 ? void 0 : _75.contentMap) === null || _76 === void 0 ? void 0 : _76.brand) === null || _77 === void 0 ? void 0 : _77.name,
                        },
                        model: {
                            id: (_80 = (_79 = (_78 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _78 === void 0 ? void 0 : _78.contentMap) === null || _79 === void 0 ? void 0 : _79.model) === null || _80 === void 0 ? void 0 : _80.id,
                            name: (_83 = (_82 = (_81 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _81 === void 0 ? void 0 : _81.contentMap) === null || _82 === void 0 ? void 0 : _82.model) === null || _83 === void 0 ? void 0 : _83.name,
                        },
                        version: {
                            id: (_86 = (_85 = (_84 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _84 === void 0 ? void 0 : _84.contentMap) === null || _85 === void 0 ? void 0 : _85.version) === null || _86 === void 0 ? void 0 : _86.id,
                            name: (_89 = (_88 = (_87 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _87 === void 0 ? void 0 : _87.contentMap) === null || _88 === void 0 ? void 0 : _88.version) === null || _89 === void 0 ? void 0 : _89.name,
                        },
                        class: {
                            id: (_92 = (_91 = (_90 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _90 === void 0 ? void 0 : _90.contentMap) === null || _91 === void 0 ? void 0 : _91.class) === null || _92 === void 0 ? void 0 : _92.id,
                            name: (_95 = (_94 = (_93 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _93 === void 0 ? void 0 : _93.contentMap) === null || _94 === void 0 ? void 0 : _94.class) === null || _95 === void 0 ? void 0 : _95.name,
                        },
                        type: {
                            id: (_98 = (_97 = (_96 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _96 === void 0 ? void 0 : _96.contentMap) === null || _97 === void 0 ? void 0 : _97.type) === null || _98 === void 0 ? void 0 : _98.id,
                            name: (_101 = (_100 = (_99 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _99 === void 0 ? void 0 : _99.contentMap) === null || _100 === void 0 ? void 0 : _100.type) === null || _101 === void 0 ? void 0 : _101.name,
                        },
                        weight: (_103 = (_102 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _102 === void 0 ? void 0 : _102.contentMap) === null || _103 === void 0 ? void 0 : _103.weight,
                        tonnage: (_105 = (_104 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _104 === void 0 ? void 0 : _104.contentMap) === null || _105 === void 0 ? void 0 : _105.tonnage,
                        passengerCant: (_107 = (_106 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _106 === void 0 ? void 0 : _106.contentMap) === null || _107 === void 0 ? void 0 : _107.passengerCant,
                    },
                ],
                year: (_109 = (_108 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _108 === void 0 ? void 0 : _108.contentMap) === null || _109 === void 0 ? void 0 : _109.year,
                carColor: [
                    {
                        id: (_112 = (_111 = (_110 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _110 === void 0 ? void 0 : _110.contentMap) === null || _111 === void 0 ? void 0 : _111.colors) === null || _112 === void 0 ? void 0 : _112.id,
                        name: (_115 = (_114 = (_113 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _113 === void 0 ? void 0 : _113.contentMap) === null || _114 === void 0 ? void 0 : _114.colors) === null || _115 === void 0 ? void 0 : _115.name,
                    },
                ],
                chassisNumber: (_117 = (_116 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _116 === void 0 ? void 0 : _116.contentMap) === null || _117 === void 0 ? void 0 : _117.chassisNumber,
                shortChassis: isChassisValid,
                price: (_119 = (_118 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _118 === void 0 ? void 0 : _118.contentMap) === null || _119 === void 0 ? void 0 : _119.deductibleTypeId,
                numberCylinders: [
                    {
                        id: (_121 = (_120 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _120 === void 0 ? void 0 : _120.contentMap) === null || _121 === void 0 ? void 0 : _121.cylinders,
                        name: (_123 = (_122 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _122 === void 0 ? void 0 : _122.contentMap) === null || _123 === void 0 ? void 0 : _123.cylinders,
                    },
                ],
                fuelType: [
                    {
                        id: (_125 = (_124 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _124 === void 0 ? void 0 : _124.contentMap) === null || _125 === void 0 ? void 0 : _125.combustion,
                        name: fuelTypeName,
                    },
                ],
                registrationNumber: (_127 = (_126 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _126 === void 0 ? void 0 : _126.contentMap) === null || _127 === void 0 ? void 0 : _127.plate,
                carCondition: [
                    {
                        id: (_129 = (_128 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _128 === void 0 ? void 0 : _128.contentMap) === null || _129 === void 0 ? void 0 : _129.condition,
                        name: carConditionName,
                    },
                ],
            });
            //EndFormVehicle
            //setStatementRows
            if (responseOneQuote.data.billing) {
                var dataRows = (_131 = (_130 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _130 === void 0 ? void 0 : _130.billing) === null || _131 === void 0 ? void 0 : _131.map(function (item) { return ({
                    accountName: item.account,
                    amount: "RD$ ".concat(item.amount),
                    paymentDate: newFormattedDate(item.paymentDate),
                    dateExpire: newFormattedDate(item.dateExpire),
                    datePaid: newFormattedDate(item.datePaid),
                    state: (function () {
                        switch (item.statusBilling) {
                            case "GENERATED":
                                return "Generado";
                            case "EMMITED":
                                return "Emitido";
                            case "PAID":
                                return "Pagado";
                            case "CANCELLED":
                                return "Cancelado";
                        }
                    })(),
                }); });
                setStatementRows(dataRows);
            }
            // EndSetStatmentRows
            // if (id) {
            // setPrime(responseOneQuote?.data?.lastPrice?.amount);
            setPrime(((_133 = (_132 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _132 === void 0 ? void 0 : _132.lastPrice) === null || _133 === void 0 ? void 0 : _133.amount)
                ? formatToTwoDecimals(responseOneQuote.data.lastPrice.amount)
                : "0.00");
            callDispatchPageActionFlags((_135 = (_134 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _134 === void 0 ? void 0 : _134.planId) === null || _135 === void 0 ? void 0 : _135.projectId);
            // Update projectId from the quote response
            if ((_137 = (_136 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _136 === void 0 ? void 0 : _136.planId) === null || _137 === void 0 ? void 0 : _137.projectId) {
                console.log("Setting projectId from quote:", responseOneQuote.data.planId.projectId);
                setProjectId(responseOneQuote.data.planId.projectId);
            }
            if (id) {
                setLocalStorage(responseOneQuote.data, responseOneProject);
                // setSteps(stepProgress(STEP));
                // setBreadCrumbs(stepProgress(STEP, true));
                if (isQuote === "false") {
                    // setSteps(stepProgress(STEP_PAYMENTCONFIRMATION));
                    setBreadCrumbs([]);
                }
                else {
                    // setSteps(stepProgress(STEP));
                    setBreadCrumbs(stepProgress(STEP, true));
                }
                var certs = (_138 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _138 === void 0 ? void 0 : _138.certificates;
                //Get the certificates
                if (certs.length > 0) {
                    certs = certs.map(function (c, id) {
                        return {
                            id: c.id,
                            name: c.title,
                            url: c.url,
                        };
                    });
                }
                setCertificates(certs);
                //Get the additional payment info
                if ((responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) && isQuote && isQuote === "false") {
                    var additionalInfo = [];
                    var data = responseOneQuote.data;
                    var lastPrice = data.lastPrice, customerAccount = data.customerAccount, catalogPaymentMode_1 = data.catalogPaymentMode, id_1 = data.id;
                    var amount = (_139 = lastPrice === null || lastPrice === void 0 ? void 0 : lastPrice.amount) !== null && _139 !== void 0 ? _139 : "0.00";
                    var currencySymbol = (lastPrice === null || lastPrice === void 0 ? void 0 : lastPrice.currencySymbol) || "";
                    var formattedAmount = formatToTwoDecimals(amount);
                    additionalInfo.push({
                        id: id_1,
                        accountName: customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.accountName,
                        accountNumber: customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.accountNumber,
                        accountType: (_140 = customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.accountType) === null || _140 === void 0 ? void 0 : _140.description,
                        paymentMode: catalogPaymentMode_1 === null || catalogPaymentMode_1 === void 0 ? void 0 : catalogPaymentMode_1.description,
                        prime: "".concat(currencySymbol, " ").concat(formattedAmount),
                        lastDigits: "N/A",
                    });
                    setRows2(additionalInfo);
                }
            }
            else {
                setRows2([
                    {
                        id: "1",
                        accountName: "N/A",
                        accountNumber: "N/A",
                        accountType: "N/A",
                        paymentMode: "N/A",
                        prime: "N/A",
                        lastDigits: "N/A",
                    },
                ]);
            }
            /*Adiciona al resumen la informacion de vehiculos*/
            switch ((_142 = (_141 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _141 === void 0 ? void 0 : _141.contentMap) === null || _142 === void 0 ? void 0 : _142.condition) {
                case "USED":
                    carConditionName = "Usado";
                    break;
                case "NEW":
                    carConditionName = "Nuevo";
                    break;
            }
            var price = ((_144 = (_143 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _143 === void 0 ? void 0 : _143.lastPrice) === null || _144 === void 0 ? void 0 : _144.currencySymbol) &&
                ((_146 = (_145 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _145 === void 0 ? void 0 : _145.lastPrice) === null || _146 === void 0 ? void 0 : _146.amount)
                ? "".concat((_148 = (_147 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _147 === void 0 ? void 0 : _147.lastPrice) === null || _148 === void 0 ? void 0 : _148.currencySymbol, " ").concat((_150 = (_149 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _149 === void 0 ? void 0 : _149.lastPrice) === null || _150 === void 0 ? void 0 : _150.amount)
                : "RD$ 0.00";
            var baseFilters = [
                {
                    name: "Producto",
                    type: "label",
                    label: (_153 = (_152 = (_151 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _151 === void 0 ? void 0 : _151.productId) === null || _152 === void 0 ? void 0 : _152.description) !== null && _153 !== void 0 ? _153 : "",
                },
                {
                    name: "Plan",
                    type: "label",
                    label: (_156 = (_155 = (_154 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _154 === void 0 ? void 0 : _154.planId) === null || _155 === void 0 ? void 0 : _155.name) !== null && _156 !== void 0 ? _156 : "",
                    showChangeButton: isQuoteType,
                },
                {
                    name: "Modalidad de Pago",
                    type: "label",
                    label: (_159 = (_158 = (_157 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _157 === void 0 ? void 0 : _157.catalogPaymentMode) === null || _158 === void 0 ? void 0 : _158.description) !== null && _159 !== void 0 ? _159 : "",
                },
                {
                    name: "Tipo de Cobertura",
                    type: "label",
                    label: (_162 = (_161 = (_160 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _160 === void 0 ? void 0 : _160.catalogPaymentMode) === null || _161 === void 0 ? void 0 : _161.description) !== null && _162 !== void 0 ? _162 : "",
                },
                {
                    name: "Campaña",
                    type: "label",
                    label: (_165 = (_164 = (_163 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _163 === void 0 ? void 0 : _163.campaignId) === null || _164 === void 0 ? void 0 : _164.name) !== null && _165 !== void 0 ? _165 : "",
                },
            ];
            var filtersPlan = [
                {
                    name: "Prima",
                    type: "label",
                    label: price,
                },
            ];
            setDefaultFilters(isQuote === "false" ? __spreadArray(__spreadArray([], baseFilters, true), filtersPlan, true) : baseFilters);
        }
        dispatch(projectOneClearData());
    }, [responseOneQuote]);
    // Separate useEffect to handle plan API call after quote data is processed
    // Only call plan API when both catalogPaymentMode.id and projectId are available
    useEffect(function () {
        var _a, _b;
        if (((_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.id) && projectId) {
            callDispatchPlan(null, null);
        }
    }, [(_p = (_o = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _o === void 0 ? void 0 : _o.catalogPaymentMode) === null || _p === void 0 ? void 0 : _p.id, projectId]); // eslint-disable-line react-hooks/exhaustive-deps
    useEffect(function () {
        var _a, _b, _c;
        if (responseOneProject) {
            setSalesFlow(responseOneProject.salesFlow);
            setProductType((_c = (_b = (_a = responseOneProject.salesFlow) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.navigation) === null || _c === void 0 ? void 0 : _c.productType);
            if (idProject) {
                // localStorageService.setStepStored({
                //   id: "",
                //   name: "",
                //   step: Steps.insurance,
                //   completed: true,
                //   flow: responseOneProject.salesFlow,
                // });
            }
        }
    }, [responseOneProject]);
    useEffect(function () {
        var _a, _b;
        if (responseGetCatalogBeneficiary && (responseGetCatalogBeneficiary === null || responseGetCatalogBeneficiary === void 0 ? void 0 : responseGetCatalogBeneficiary.data)) {
            var beneficiaryList_1 = [];
            (_a = responseGetCatalogBeneficiary.data) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                beneficiaryList_1.push({
                    id: item.id,
                    name: item.description ? item.description : "",
                    value: item.id,
                });
            });
            setBeneficiaryType(beneficiaryList_1);
            setDataFormBeneficiary(__assign(__assign({}, dataFormBeneficiary), { idTypeInsured: (_b = beneficiaryList_1[0].value) !== null && _b !== void 0 ? _b : "" }));
        }
    }, [responseGetCatalogBeneficiary]);
    useEffect(function () {
        var _a, _b;
        if (responseGetCatalogInsurance && (responseGetCatalogInsurance === null || responseGetCatalogInsurance === void 0 ? void 0 : responseGetCatalogInsurance.data)) {
            var insuranceList_1 = [];
            (_a = responseGetCatalogInsurance.data) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                var _a;
                insuranceList_1.push({
                    id: item.id,
                    name: item.description ? item.description : "",
                    value: item.id,
                    code: (_a = item.code) !== null && _a !== void 0 ? _a : "",
                });
            });
            setInsuredType(insuranceList_1);
            setDataFormInsurance(__assign(__assign({}, dataFormInsurance), { idTypeInsured: (_b = insuranceList_1[0].value) !== null && _b !== void 0 ? _b : "" }));
        }
    }, [responseGetCatalogInsurance]);
    useEffect(function () {
        var _a, _b, _c;
        if (responsePlans) {
            var dataST_1 = [];
            // Prioritize payment mode from quote data
            var paymentModeFromQuote = (_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.description;
            var pm = (_c = localStorageService.getStepStored().steps[Steps.plan]
                .paymentModeSelected) === null || _c === void 0 ? void 0 : _c.name;
            // Use quote data first, then period state, then localStorage
            var paymentPeriod_1 = paymentModeFromQuote || period || pm;
            if (period === undefined && paymentPeriod_1) {
                setPeriod(paymentPeriod_1);
            }
            responsePlans.map(function (item) {
                var _a;
                dataST_1.push({
                    id: item.id,
                    name: item.name ? item.name.replace(/"/g, "") : "",
                    logo: item.sponsorLogoUrl && item.sponsorLogoUrl,
                    backgroundColor: "#ffffff",
                    currency: "$",
                    itemsValue: [],
                    option: setCoverTypeStorybook(item.coverTypes ? item.coverTypes : []),
                    period: paymentPeriod_1,
                    price: item.price ? (_a = item.price) === null || _a === void 0 ? void 0 : _a.amount : "0",
                    textColor: "#3A56A1",
                });
            });
            setPlanData(__assign(__assign({}, plan), { data: dataST_1 }));
        }
    }, [responsePlans, responseOneQuote]);
    /*
    useEffect(() => {
      if (permissionList?.length > 0) {
        setTriggerPermissionList(false);
      }
    }, [permissionList]);
  */
    useEffect(function () {
        if (listIdentificationType.length > 0 &&
            listGenders.length > 0 &&
            listCountries.length > 0 &&
            listRegionLevel1.length > 0 &&
            listRegionLevel2.length > 0 &&
            listRegionLevel3.length > 0 &&
            !showComponent) {
            setShowComponent(true);
        }
    }, [
        listIdentificationType,
        listGenders,
        listCountries,
        listRegionLevel1,
        listRegionLevel2,
        listRegionLevel3,
    ]);
    useEffect(function () {
        if (responsePageActionFlags) {
            lsPageActionFlags.setPageActionFlagsStored(responsePageActionFlags);
            setActionFlags(responsePageActionFlags);
            getActionFlags();
            dispatch(pageActionFlagsClearData());
            responsePageActionFlags === null || responsePageActionFlags === void 0 ? void 0 : responsePageActionFlags.forEach(function (actionFlag) {
                if (actionFlag.name === "afy-show-plan-travel-range-info") {
                    console.log("Travel Insurance Flag Found", premiumSum);
                    setIsTravelInsurance(true);
                }
            });
        }
    }, [responsePageActionFlags]);
    useEffect(function () {
        if (responsePatchBeneficiary && responsePatchBeneficiary.data) {
            showToastSuccessMessage("Beneficiario actualizado con éxito.", typeAlert.success, setSeeToast);
            setOpenModal(false);
            dispatch(patchBeneficiaryClearData());
            getInsuredBeneficiary();
        }
    }, [responsePatchBeneficiary]);
    useEffect(function () {
        if (responsePatchInsured && responsePatchInsured.data) {
            showToastSuccessMessage("Asegurado actualizado con éxito.", typeAlert.success, setSeeToast);
            setOpenModal(false);
            // dispatch(person({ enable: true, page: 1, limit: 1000 }));
            dispatch(patchInsuredClearData());
            getInsuredBeneficiary();
        }
    }, [responsePatchInsured]);
    useEffect(function () {
        if (responsePostInsured) {
            showToastSuccessMessage("Asegurado agregado con éxito.", typeAlert.success, setSeeToast);
            setOpenModal(false);
            setOpenModalAddInsurance(false);
            getInsuredBeneficiary();
        }
    }, [responsePostInsured]);
    useEffect(function () {
        if (responseUpdatePerson === null || responseUpdatePerson === void 0 ? void 0 : responseUpdatePerson.data) {
            showToastSuccessMessage("Agregado con éxito.", typeAlert.success, setSeeToast);
            // if (id !== undefined) {
            dispatch(quoteClearData());
            dispatch(quoteOne({ id: id !== null && id !== void 0 ? id : quoteId, fullBody: true }));
            // } else {
            //   dispatch(
            //     quoteOne({
            //       id: quoteId ?? id,
            //       fullBody: true,
            //     }),
            //   );
            // }
        }
    }, [responseUpdatePerson]);
    useEffect(function () {
        if (responseBenefit && (responseBenefit === null || responseBenefit === void 0 ? void 0 : responseBenefit.data)) {
            showToastSuccessMessage("Beneficiario agregado con éxito.", typeAlert.success, setSeeToast);
            setOpenModalBeneficiary(false);
            getInsuredBeneficiary();
            dispatch(benefitClearData());
        }
    }, [responseBenefit]);
    useEffect(function () {
        if (responsePlan && responsePlan.data) {
            // Payment mode selection is now handled by responsePaymentMode useEffect
            // This ensures paymentModelSelected is set from the dedicated PaymentModes API
        }
    }, [responsePlan]);
    useEffect(function () {
        var _a, _b, _c, _d;
        if (responseIdentificationType &&
            ((_a = responseIdentificationType.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var idf_1 = [];
            (_b = responseIdentificationType.data) === null || _b === void 0 ? void 0 : _b.map(function (item) {
                idf_1.push({
                    id: item.id,
                    name: item.description ? item.description : "",
                    value: item.id,
                });
            });
            setListIdentificationType(idf_1);
            setDataFormBeneficiary(__assign(__assign({}, dataFormBeneficiary), { IdType: (_c = idf_1[0].value) !== null && _c !== void 0 ? _c : "" }));
            setDataFormInsurance(__assign(__assign({}, dataFormInsurance), { IdType: (_d = idf_1[0].value) !== null && _d !== void 0 ? _d : "" }));
        }
        else {
            //navigate("/customerForm");
        }
    }, [responseIdentificationType]);
    useEffect(function () {
        var _a, _b;
        if (responseCatalogGender && ((_a = responseCatalogGender.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var data = (_b = responseCatalogGender.data) === null || _b === void 0 ? void 0 : _b.map(function (gender) {
                return {
                    id: gender.id,
                    value: gender.id,
                    name: gender.description,
                };
            });
            setListGenders(data);
        }
        else {
            //navigate("/customerForm");
        }
    }, [responseCatalogGender]);
    useEffect(function () {
        var _a, _b;
        if (responseCountries && ((_a = responseCountries.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var data = (_b = responseCountries.data) === null || _b === void 0 ? void 0 : _b.map(function (country) {
                return {
                    id: country.id,
                    value: country.id,
                    name: country.description,
                };
            });
            setListCountries(data);
        }
        else {
            //navigate("/customerForm");
        }
    }, [responseCountries]);
    useEffect(function () {
        var _a;
        if (responseRegion && (responseRegion === null || responseRegion === void 0 ? void 0 : responseRegion.data)) {
            var data = (_a = responseRegion.data) === null || _a === void 0 ? void 0 : _a.map(function (region) {
                return {
                    id: region.id,
                    value: region.id,
                    name: region.name,
                };
            });
            data.unshift({ id: "-1", value: "-1", name: " " });
            if (responseRegion.level === level1) {
                setListRegionLevel1(data);
            }
            else if (responseRegion.level === level2) {
                if (data.length > 0) {
                    setListRegionLevel2(data);
                }
                else {
                    setListRegionLevel2([{ id: "-1", value: "-1", name: " " }]);
                }
            }
            else if (responseRegion.level === level3) {
                if (data.length > 0) {
                    setListRegionLevel3(data);
                }
                else {
                    setListRegionLevel3([{ id: "-1", value: "-1", name: " " }]);
                }
            }
        }
    }, [responseRegion]);
    useEffect(function () {
        if (responseBeneficiary === null || responseBeneficiary === void 0 ? void 0 : responseBeneficiary.data) {
            setBeneficiaryStorybook(responseBeneficiary.data);
        }
    }, [responseBeneficiary === null || responseBeneficiary === void 0 ? void 0 : responseBeneficiary.data]);
    useEffect(function () {
        if (responseInsured === null || responseInsured === void 0 ? void 0 : responseInsured.data) {
            setInsuranceStorybook(responseInsured === null || responseInsured === void 0 ? void 0 : responseInsured.data);
            setSessionData(responseInsured);
        }
    }, [responseInsured]);
    useEffect(function () {
        if (responsePlan && responsePlan.data) {
            /* Payment modes are now loaded from dedicated API - see useEffect for responsePaymentMode */
            /* Filtrar por coverage type */
            var result = filterData(responsePlan.data, "type", catalogConst.CATALOG_BENEFICIARY_TYPE);
            if (result.length > 0) {
                setCoverageType(result);
            }
            /* Filtrar por insured type */
            result = filterData(responsePlan.data, "type", catalogConst.CATALOG_INSURED_TYPE);
            // if (result.length > 0) {
            //   setInsuredType(result);
            //   setDataFormInsurance({
            //     ...dataFormInsurance,
            //     idTypeInsured: result[0].value ?? "",
            //   });
            // }
            /* Filtrar por beneficiary type */
            result = filterData(responsePlan.data, "type", catalogConst.CATALOG_BENEFICIARY_TYPE);
            // if (result.length > 0) {
            //   setBeneficiaryType(result);
            //   setDataFormBeneficiary({
            //     ...dataFormBeneficiary,
            //     idTypeInsured: result[0].value ?? "",
            //   });
            // }
        }
    }, [responsePlan]);
    useEffect(function () {
        if (actionFlags.length > 0) {
            getActionFlags();
        }
    }, [actionFlags]);
    useEffect(function () {
        var _a, _b, _c, _d, _e;
        if (!((_a = summary === null || summary === void 0 ? void 0 : summary.data) === null || _a === void 0 ? void 0 : _a.length)) {
            setFilters(defaultFilters);
            return;
        }
        var byLabel = Object.fromEntries(summary.data.map(function (i) { return [i.label, i.value]; }));
        // Orden grupo deseado
        var header = ["Documento", "No. de cotización"];
        var cliente = ["Nombres", "Apellidos"];
        var used = new Set(__spreadArray(__spreadArray([], header, true), cliente, true));
        var producto = summary.data.filter(function (i) { return !used.has(i.label); });
        var out = __spreadArray([
            {
                name: "Número de cotización",
                label: (_b = byLabel["No. de cotización"]) !== null && _b !== void 0 ? _b : "-",
                type: "label",
            },
            {
                name: "Número de documento",
                label: (_c = byLabel["Documento"]) !== null && _c !== void 0 ? _c : "-",
                type: "label",
            },
            // Subtítulo cliente
            {
                name: "Datos del cliente",
                label: "Datos del cliente",
                type: "subtitle",
            },
            { name: "Nombres", label: (_d = byLabel["Nombres"]) !== null && _d !== void 0 ? _d : "-", type: "label" },
            { name: "Apellidos", label: (_e = byLabel["Apellidos"]) !== null && _e !== void 0 ? _e : "-", type: "label" },
            // Subtítulo producto
            {
                name: "Datos del producto",
                label: "Datos del producto",
                type: "subtitle",
            }
        ], producto.map(function (e) { return ({
            name: e.label,
            label: e.value,
            type: "label",
        }); }), true);
        setFilters(out);
    }, [summary, defaultFilters]);
    useEffect(function () {
        if (responsePersonByDocument && responsePersonByDocument.length > 0) {
            var dataPerson = responsePersonByDocument[0];
            var updatedDataFormPerson = updateDataFormPerson(dataPerson, isInsurance ? dataFormInsurance : dataFormBeneficiary);
            if (isInsurance) {
                setDataFormInsurance(updatedDataFormPerson);
            }
            else {
                setDataFormBeneficiary(updatedDataFormPerson);
            }
            setTrigger(false);
            dispatch(personByDocumentClearData());
        }
        if ((responsePersonByDocument === null || responsePersonByDocument === void 0 ? void 0 : responsePersonByDocument.length) === 0) {
            if (isInsurance) {
                setDataFormInsurance({
                    Name: "",
                    SecondName: "",
                    LastNameA: "",
                    LastNameB: "",
                    marriedName: "",
                    Birthday: "",
                    PhoneNumber: "",
                });
            }
            else {
                setDataFormBeneficiary({
                    Name: "",
                    SecondName: "",
                    LastNameA: "",
                    LastNameB: "",
                    marriedName: "",
                    Birthday: "",
                    PhoneNumber: "",
                });
            }
            dispatch(personByDocumentClearData());
        }
    }, [responsePersonByDocument, isInsurance, trigger]);
    useEffect(function () {
        setUploadTrigger(false);
        setOpenDrawerUpload(false);
        dispatch(postQuoteUploadDocumentClearData());
        if (id !== undefined) {
            dispatch(quoteClearData());
            callQuoteOne(id);
        }
        else {
            callQuoteOne(quoteId);
        }
    }, [responseUploadDocuments]);
    var columnsInsurance = Tab1Columns(editInsured, canEditInsured);
    var columnsBeneficiary = Tab2Columns(editBeneficiary, canEditBeneficiary);
    var callGetInsuredBeneficiary = function (quoteId) {
        var id_ = quoteId;
        if (id_) {
            if (!(responseInsured === null || responseInsured === void 0 ? void 0 : responseInsured.data) && !(responseBeneficiary === null || responseBeneficiary === void 0 ? void 0 : responseBeneficiary.data)) {
                dispatch(getBeneficiary({
                    enable: true,
                    page: 1,
                    limit: 100,
                    quoteId: id_,
                }));
                dispatch(insured({
                    enable: true,
                    page: 1,
                    limit: 100,
                    quoteId: id_,
                }));
            }
        }
    };
    // Passenger Download Modal State
    var _117 = useState(false), openPassengerModal = _117[0], setOpenPassengerModal = _117[1];
    var _118 = useState(false), openModalAddPassenger = _118[0], setOpenModalAddPassenger = _118[1];
    var _119 = useState(""), selectedQuoteId = _119[0], setSelectedQuoteId = _119[1];
    var _120 = useState(null), editingPassengerId = _120[0], setEditingPassengerId = _120[1];
    var _121 = useState(null), editingPassengerData = _121[0], setEditingPassengerData = _121[1];
    var handleAddPassanger = function () {
        setEditingPassengerId(null);
        setEditingPassengerData(null);
        setOpenModalAddPassenger(true);
    };
    var onClickPassangerDownload = React.useCallback(function () {
        setSelectedQuoteId(quoteId);
        setOpenPassengerModal(true);
    }, [quoteId]);
    var handlePassengerModalClose = React.useCallback(function () {
        setOpenPassengerModal(false);
        setSelectedQuoteId("");
    }, []);
    var handleOpenPdf = React.useCallback(function (url, name) {
        setUrlDocumentPassenger(url);
        setNameDocumentPassenger(name);
        setOpenModalPassenger(true);
    }, []);
    var handleEditPassenger = React.useCallback(function (row) {
        var _a, _b;
        console.log("Editing passenger:", row);
        setEditingPassengerId(row.row.id);
        // Find the original IDs from the names
        var idTypeId = ((_a = listIdentificationType.find(function (item) { return item.name === row.row.idType; })) === null || _a === void 0 ? void 0 : _a.id) || "";
        var genderId = ((_b = listGenders.find(function (item) { return item.name === row.row.gender; })) === null || _b === void 0 ? void 0 : _b.id) || "";
        setEditingPassengerData({
            Name: row.row.name,
            LastName: row.row.lastName,
            IdType: idTypeId,
            DocumentNumber: row.row.documentNumber,
            Birthday: row.row.birthDate,
            Gender: genderId,
            Email: row.row.email,
            PhoneNumber: row.row.phone,
        });
        setOpenModalAddPassenger(true);
    }, [listIdentificationType, listGenders]);
    var handleDeletePassenger = React.useCallback(function (row) {
        console.log("Deleting passenger:", row);
        setRowsPassengers(function (prev) { return prev.filter(function (p) { return p.id !== row.row.id; }); });
    }, []);
    var handleSavePassenger = React.useCallback(function (data) {
        var _a, _b, _c, _d, _e, _f, _g;
        console.log("Data from passenger to save:", data);
        // Use data from responsePersonByDocument if available, otherwise use form data
        var personData = responsePersonByDocument && responsePersonByDocument.length > 0
            ? responsePersonByDocument[0]
            : null;
        console.log("Person data from responsePersonByDocument:", personData);
        // Find identification type name
        var idTypeObj = listIdentificationType.find(function (item) { var _a; return item.id === (((_a = personData === null || personData === void 0 ? void 0 : personData.identificationTypeId) === null || _a === void 0 ? void 0 : _a.id) || data.IdType); });
        var genderObj = listGenders.find(function (item) { var _a; return item.id === (((_a = personData === null || personData === void 0 ? void 0 : personData.catalogGender) === null || _a === void 0 ? void 0 : _a.id) || data.Gender); });
        var rawBirthDate = (personData === null || personData === void 0 ? void 0 : personData.dob) || data.Birthday || "";
        var formattedBirthDate = rawBirthDate ? newFormattedDate(rawBirthDate) : "";
        var age = rawBirthDate ? calculateAge(rawBirthDate) : 0;
        // Create or update passenger row
        var passengerRow = {
            id: editingPassengerId || rowsPassengers.length + 1,
            name: (personData === null || personData === void 0 ? void 0 : personData.firstNameA) || data.Name || "",
            lastName: (personData === null || personData === void 0 ? void 0 : personData.lastNameA) || data.LastName || "",
            idType: (idTypeObj === null || idTypeObj === void 0 ? void 0 : idTypeObj.name) || "",
            documentNumber: (personData === null || personData === void 0 ? void 0 : personData.numberId) || data.DocumentNumber || "",
            birthDate: formattedBirthDate,
            age: age,
            gender: (genderObj === null || genderObj === void 0 ? void 0 : genderObj.name) || "",
            passport: data.Passport || "",
            email: (personData === null || personData === void 0 ? void 0 : personData.email) || data.Email || "",
            phone: (personData === null || personData === void 0 ? void 0 : personData.phone1) || (personData === null || personData === void 0 ? void 0 : personData.phone3) || data.PhoneNumber || "",
        };
        if (editingPassengerId) {
            // Update existing passenger
            setRowsPassengers(function (prev) { return prev.map(function (p) { return p.id === editingPassengerId ? passengerRow : p; }); });
            console.log("Passenger updated in table:", passengerRow);
            setEditingPassengerId(null);
            setEditingPassengerData(null);
        }
        else {
            // Add new passenger
            setRowsPassengers(function (prev) { return __spreadArray(__spreadArray([], prev, true), [passengerRow], false); });
            console.log("Passenger added to table:", passengerRow);
        }
        // Only add insured if there are no existing insured records
        if (!(responseInsured === null || responseInsured === void 0 ? void 0 : responseInsured.data) || responseInsured.data.length === 0) {
            console.log("No insured records found, creating insured from passenger data");
            // Map passenger data to insured body structure
            var body = {
                quoteId: quoteId || id,
                catalogInsuredType: ((_a = insuredType[0]) === null || _a === void 0 ? void 0 : _a.value) || "f97da54f-2ee9-4bca-8063-596b74057e34",
                person: {
                    firstNameA: (personData === null || personData === void 0 ? void 0 : personData.firstNameA) || data.Name || "",
                    firstNameB: (personData === null || personData === void 0 ? void 0 : personData.firstNameB) || data.SecondName || "",
                    lastNameA: (personData === null || personData === void 0 ? void 0 : personData.lastNameA) || data.LastName || data.FirstLastName || "",
                    lastNameB: (personData === null || personData === void 0 ? void 0 : personData.lastNameB) || data.SecondLastName || "",
                    identificationTypeId: ((_b = personData === null || personData === void 0 ? void 0 : personData.identificationTypeId) === null || _b === void 0 ? void 0 : _b.id) || data.IdType || "",
                    numberId: ((personData === null || personData === void 0 ? void 0 : personData.numberId) || data.DocumentNumber || "").replace(/-/g, ""),
                    dob: (personData === null || personData === void 0 ? void 0 : personData.dob) || data.Birthday || "",
                    catalogGender: ((_c = personData === null || personData === void 0 ? void 0 : personData.catalogGender) === null || _c === void 0 ? void 0 : _c.id) || data.Gender || "",
                    marriedName: (personData === null || personData === void 0 ? void 0 : personData.marriedName) || data.MarriedSurName || "",
                    nationality: ((_d = personData === null || personData === void 0 ? void 0 : personData.nationality) === null || _d === void 0 ? void 0 : _d.id) || data.Country || clientId,
                    province: ((_e = personData === null || personData === void 0 ? void 0 : personData.province) === null || _e === void 0 ? void 0 : _e.id) || data.Province || "",
                    municipality: ((_f = personData === null || personData === void 0 ? void 0 : personData.municipality) === null || _f === void 0 ? void 0 : _f.id) || data.Town || "",
                    district: ((_g = personData === null || personData === void 0 ? void 0 : personData.district) === null || _g === void 0 ? void 0 : _g.id) || data.Sector || "",
                    zip: (personData === null || personData === void 0 ? void 0 : personData.zip) || data.PostalCode || "",
                    address1: (personData === null || personData === void 0 ? void 0 : personData.address1) || data.Address1 || "",
                    phone1: removeNonNumeric((personData === null || personData === void 0 ? void 0 : personData.phone1) || data.PhoneHome || data.PhoneNumber || null),
                    phone3: removeNonNumeric((personData === null || personData === void 0 ? void 0 : personData.phone3) || data.PhoneNumber || null),
                    phone2: removeNonNumeric((personData === null || personData === void 0 ? void 0 : personData.phone2) || data.PhoneOffice || null),
                    email: (personData === null || personData === void 0 ? void 0 : personData.email) || data.Email || "",
                    clientId: clientId,
                },
            };
            console.log("Creating insured with body:", body);
            //dispatch(postInsured(body));
        }
        else {
            console.log("Insured records exist, skipping insured creation");
        }
        setOpenModalAddPassenger(false);
    }, [quoteId, id, responseInsured, responsePersonByDocument, insuredType, clientId, dispatch, rowsPassengers, listIdentificationType, listGenders]);
    // Calculate passenger age from birth date
    var calculateAge = function (birthDate) {
        if (!birthDate)
            return 0;
        var today = new Date();
        var birth = new Date(birthDate);
        var age = today.getFullYear() - birth.getFullYear();
        var monthDiff = today.getMonth() - birth.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
            age--;
        }
        return age;
    };
    // Validate passengers match age ranges
    var validatePassengerAges = function () {
        if (!isTravelInsurance || rowsPassengers.length === 0)
            return true;
        var ageRanges = {
            edad020: 0,
            edad2174: 0,
            edad7585: 0,
        };
        // Count passengers in each age range
        rowsPassengers.forEach(function (passenger) {
            var age = calculateAge(passenger.birthDate);
            if (age >= 0 && age <= 20) {
                ageRanges.edad020++;
            }
            else if (age >= 21 && age <= 74) {
                ageRanges.edad2174++;
            }
            else if (age >= 75 && age <= 85) {
                ageRanges.edad7585++;
            }
        });
        console.log("Age range counts:", ageRanges);
        console.log("Expected counts - edad020:", edad020, "edad2174:", edad2174, "edad7585:", edad7585);
        // Check if age ranges match the exact expected counts
        var edad020Match = ageRanges.edad020 === edad020;
        var edad2174Match = ageRanges.edad2174 === edad2174;
        var edad7585Match = ageRanges.edad7585 === edad7585;
        console.log("Validation results - edad020Match:", edad020Match, "edad2174Match:", edad2174Match, "edad7585Match:", edad7585Match);
        return edad020Match && edad2174Match && edad7585Match;
    };
    // Calculate total expected passengers from premium sum
    var getTotalExpectedPassengers = function () {
        var total = 0;
        if (edad020 > 0)
            total++;
        if (edad2174 > 0)
            total++;
        if (edad7585 > 0)
            total++;
        return total;
    };
    // Check if passenger validation passes
    var isPassengerValidationPassed = isTravelInsurance
        ? (rowsPassengers.length === premiumSum && validatePassengerAges())
        : true;
    // Generate passenger requirement message
    var getPassengerRequirementMessage = function () {
        if (!isTravelInsurance)
            return "";
        var requirements = [];
        if (edad020 > 0)
            requirements.push("".concat(edad020, " pasajero").concat(edad020 > 1 ? 's' : '', " (0-20 a\u00F1os)"));
        if (edad2174 > 0)
            requirements.push("".concat(edad2174, " pasajero").concat(edad2174 > 1 ? 's' : '', " (21-74 a\u00F1os)"));
        if (edad7585 > 0)
            requirements.push("".concat(edad7585, " pasajero").concat(edad7585 > 1 ? 's' : '', " (75-85 a\u00F1os)"));
        var currentCount = rowsPassengers.length;
        var requiredCount = premiumSum;
        return "Se requiere".concat(requirements.length > 0 ? ': ' + requirements.join(', ') : 's ' + requiredCount + ' pasajero' + (requiredCount > 1 ? 's' : ''), ". Agregados: ").concat(currentCount, "/").concat(requiredCount);
    };
    var columnsPassenger = React.useMemo(function () { return __spreadArray([
        {
            field: "actions",
            headerName: "Acciones",
            width: 150,
            renderCell: function (params) { return (_jsx(_Fragment, { children: _jsx(ButtonAFY, { size: sizes.small, variant: variants.text, label: "Eliminar", color: themeCore.colors.error, onClick: function () { return handleDeletePassenger(params); } }) })); },
        }
    ], Tab4Columns, true); }, [handleEditPassenger, handleDeletePassenger]);
    return (_jsxs(React.Fragment, { children: [_jsx(PagesHeader, { titlePage: titleInsured, hideStep: isQuote === "false", steps: steps, completed: isQuote === "false" }), _jsx(ConfirmationHeader, { loading: loadingPostInsured ||
                    loadingUpdatePerson ||
                    loadingOneQuote ||
                    loadingBenefit ||
                    loadingPostInsured ||
                    loadingPatchBeneficiary ||
                    loadingPatchInsured ||
                    loadingPersonByDocument ||
                    loadingOneProject ||
                    loadingBeneficiary ||
                    loading ||
                    loadingPlans ||
                    loadingUpdateQuote ||
                    loadingUploadDocuments ||
                    loadingGetCatalogBeneficiary ||
                    loadingGetCatalogInsurance ||
                    loadingCertificateQuote ||
                    loadingInsured ||
                    loadingPaymentMode ||
                    loadingComplete, text: loadingUpdatePerson || loadingUpdateQuote
                    ? "Actualizando datos."
                    : loadingUploadDocuments
                        ? "Subiendo documento..."
                        : "Cargando...", seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast }), openPassengerModal && (_jsx(PassengerDownloadModal, { open: openPassengerModal, onClose: handlePassengerModalClose, setSeeToast: setSeeToast, quoteId: selectedQuoteId, onOpenPdf: handleOpenPdf })), showComponent ? (_jsx(Suspense, { children: _jsx(ConfirmationFormView, { onClickPassangerDownload: onClickPassangerDownload, isTravelInsurance: isTravelInsurance, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, breadcrumbs: breadCrumbs, steps: steps, 
                    /* PDF VIEWER DOCUMENT*/
                    openModal: openModalPdfViewer, setOpenModal: setopenModalPdfViewer, documentName: nameDocument, urlDocument: urlDocument, 
                    /* PDF VIEWER CLIENT*/
                    openModalClient: modalDocumentClient, setOpenModalClient: setModalDocumentClient, documentNameClient: docName, urlDocumentClient: urlDocumentClient, 
                    /* PDF VIEWER PASSENGER */
                    openModalPassenger: openModalPassenger, setOpenModalPassenger: setOpenModalPassenger, documentNamePassenger: nameDocumentPassenger, urlDocumentPassenger: urlDocumentPassenger, 
                    /* MODAL EDIT VEHICLE */
                    openModalEditVehicle: openModalEditVehicle, setOpenModalEditVehicle: setOpenModalEditVehicle, dataFormVehicle: dataFormVehicle, callQuoteOneApi: callQuoteOne, quoteId: id ? id : quoteId, planId: planId, coverTypeId: coverTypeId, campaignId: campaignId, catalogPaymentMode: catalogPaymentMode, catalogStatusQuote: catalogStatusQuote, branchId: branchId, userId: userId, idQuoteVehicle: idQuoteVehicle, productId: productId, t: t, planName: planName, productType: productType, projectTypeLocal: projectTypeLocal, salesFlow: salesFlow, 
                    /* MODAL BENEFICIARY */
                    openModalBeneficiary: openModalBeneficiary, setOpenModalBeneficiary: setOpenModalBeneficiary, isMaskedDocument: isMaskedDocument, dataFormBeneficiary: dataFormBeneficiary, titleBeneficiary: titleBeneficiary, beneficiaryType: beneficiaryType, listIdentificationType: listIdentificationType, initialPercentage: initialPercentage, handleSubmitBeneficiary: function () {
                        return handleSubmitBeneficiary(dataFormBeneficiary);
                    }, searchPerson: function (e) {
                        return searchPerson(e, setIsInsurance, setDocument, setTrigger);
                    }, 
                    /* MODAL INSURED */
                    openModalInsured: openModal, setOpenModalInsured: setOpenModal, dataFormInsurance: dataFormInsurance, titleInsured: titleInsured, insuredType: insuredType, handleSubmitInsured: function (data) { return handleSubmitInsured(data); }, searchInsurancePerson: function (e) { return searchInsurancePerson(e); }, 
                    /* MODAL CONFIRMATION */
                    openModalBackConfirm: openModalBackConfirm, handleCloseBackModal: handleCloseBackModal, handleBackFromModal: handleBackFromModal, classes: classes, 
                    /* VIEW */
                    isRequired: !isApap, tabAdditionalDocumentation: "Documentos Clientes", countBadgeContent: countBadge, customBadgeColor: "#fba730", badgeColorText: "#ffffff", additionalDocumentationColumns: AdditionalDocumentationColumns(handleClickContextMenu), additionalDocumentationRows: profileDocumentsRows, hideMarriedName: hideMarriedName, titleDrawer: "Suba el documento solicitado.", descriptionDrawer: "Arrastra el documento solicitado a la zona de color o haz clic en el área de color para seleccionarlo. Solo puedes subir un documento a la vez, y solo se permiten archivos en formato PDF.", titleUpload: "Arrastre y suelte su archivo.", heightDrawer: "100%", disableSelectCountry: true, openDrawerUpload: openDrawerUpload, onCloseDrawer: function () {
                        setOpenDrawerUpload(false);
                    }, onUpload: quoteUploadDocuments, tabAuto: "Auto Asegurado", tabAutoDescription: "", tabStatement: "Estado de cuenta", tabStatementColumns: StatementColumns(t), tabStatementRows: statementRows, TabAutoColumns: TabAutoColumns(updateVehicle, isQuote ? isQuote : ""), TabAutoRows: listVehiclesDetail, onChangeSelect: handleChangeSelect, handleChangeSelectFormInsurance: handleChangeSelectFormInsurance, 
                    // ***--- PROPS BOTONES DESCARGAR QUOTE DESDE RESUMEN
                    onClickAutoDownload: handleOnClickAutoDownload, btnLblDownload: "Descargar Cotización", showButtonDownloadApap: !showVehicleData || !showDownloadQuote, onClickAutoDownloadVida: handleOnClickAutoDownloadVida, btnLblDownloadVida: "Descargar Solicitud", showButtonDownloadVida: !showDownloadRequest, 
                    // ***--- END PROPS BOTONES DESCARGAR QUOTE DESDE RESUMEN
                    labelNumberQuote: ((_q = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _q === void 0 ? void 0 : _q.policyId)
                        ? "No. de póliza"
                        : "No. de cotización", title: "Confirmación de datos", identificationList: listIdentificationType, GenderList: listGenders, CountryList: listCountries, ProvinceList: listRegionLevel1, TownList: listRegionLevel2, SectorList: listRegionLevel3, dataForm: dataForm, hideTabs: [
                        showInsured,
                        showBeneficiary,
                        !(isQuote === "false"),
                        showVehicleData,
                        true,
                        hideTabDocumentClient,
                        !isTravelInsurance,
                    ], hideAddButton: [addInsured, addBeneficiary], showAdd: true, showActions: canEdit, showContactActions: canEditContact, showLocationActions: canEditLocation, showDownloads: !canEdit, onClickDownload: handleDownload, certificates: certificates, dateLabel: isQuote !== null && isQuote === "false"
                        ? "Fecha efectiva"
                        : "Fecha de cotización", downloadsTitle: "Descargas", labelAdd: "Agregar", tab1: "Personas aseguradas", tab1Description: "Asegurados", tab2: "Beneficiarios", tab2Description: "Beneficiarios", tab3: "Información de pago", tab3Description: "", Tab1Columns: columnsInsurance, Tab1Rows: rows, Tab2Columns: columnsBeneficiary, Tab2Rows: rowsBeneficiary, Tab3Columns: Tab3Columns, Tab3Rows: rows2, 
                    //Travel Insurance Tab4
                    tab4: "Pasajeros", tab4Description: getPassengerRequirementMessage(), Tab4Columns: columnsPassenger, Tab4Rows: rowsPassengers, hide2: true, options1: paymentMode, options2: [], options3: campaignInfo, firstSubtitle: "Información de cotización", secondSubtitle: "Información general del cliente", thirdSubtitle: "Información de ubicación", fourthSubtitle: "Información de contacto", plan: plan, plans: planData.data || [], paymentMethodData: paymentMode, campaignData: campaign, showPaymentMethod: true, showCampaign: true, onClickAdd: handleAddInsured, onClickRowGrid: function () { }, onClickAddBeneficiary: handleAddBeneficiary, filters: filters, titleSelectButton: "Adquirir", previousLabel: "Anterior", nextLabel: !isVidaTermino ? "Siguiente" : "Finalizar", showPrevious: canEdit, nextDisabled: !permissions.create || !canEdit || isNextDisabled || !isPassengerValidationPassed, onBack: onClickBack, onClickSave: handleUpdatePerson, onNext: handleNext, onClickPrevious: handlePrevious, onBlurInput: function () { }, onChangeInput: function () { }, onClickCancel: function () { }, disableDocumentType: true, disableDocumentNumber: true, onChangePaymentMethod: handleOnChangePaymentMethod, onChangeCampaign: handleOnChangeCampaign, onChangeCoverType: handleOnChangeCoverType, onClickAcquire: handleOnClickAcquire, disabledDownloadVida: false, isQuote: isQuote, isPlan: isPlan, openModalAddInsurance: openModalAddInsurance, setOpenModalAddInsurance: setOpenModalAddInsurance, dataFormInsuranceSp: dataFormInsuranceSp, showButtonActivatePolicy: showButtonActivatePolicy, openActivePolicy: openActivePolicy, setOpenActivePolicy: setOpenActivePolicy, policyId: policyId, callQuoteOne: callQuoteOne, onClickAddPassanger: handleAddPassanger, openModalAddPassenger: openModalAddPassenger, setOpenModalAddPassenger: setOpenModalAddPassenger, editingPassengerData: editingPassengerData, handleSavePassenger: handleSavePassenger }) })) : (_jsx("div", {}))] }));
};
export default ConfirmationForm;
